export const ru = {
  // Nav/chrome
  'nav.catalog': 'Каталог',
  'nav.tender': 'Тендер',
  'nav.login': 'Войти',
  'nav.dashboard': 'Панель управления',
  'nav.signOut': 'Выйти',
  // Landing
  'landing.hero.title': 'Найдите деловые возможности',
  'landing.hero.description':
    'Просматривайте государственные тендеры по всей стране. Фильтруйте по региону, категории и статусу.',
  'landing.hero.browseCatalog': 'Открыть каталог',
  'landing.recentTenders': 'Последние тендеры',
  // Catalog
  'catalog.title': 'Каталог тендеров',
  'catalog.loading': 'Загрузка тендеров…',
  'error.title': 'Не удалось загрузить. Проверьте соединение.',
  'error.retry': 'Повторить',
  'error.searchBusy':
    'Сейчас на сайте много поисков одновременно. Сайт работает: повторите через несколько секунд.',
  'error.searchTooMany':
    'Ваши предыдущие поиски ещё выполняются. Дождитесь результата и повторите.',
  'catalog.slowLoad':
    'Ищем дольше обычного. Сайт работает, результаты появятся через несколько секунд.',
  'catalog.filters': 'Фильтры',
  // Deliberately NOT a list of the fields. The sheet's contents vary by route
  // — the status control is dropped where the route fixes the status — so an
  // inventory drifts into a lie, and a screen-reader user is told about a
  // control that is not there. The description exists to say what the dialog
  // is FOR; the fields announce themselves.
  'catalog.filters.a11yDesc': 'Фильтры каталога тендеров.',
  'catalog.filtersApply': 'Показать результаты',
  'catalog.export': 'Экспорт в Excel',
  'catalog.exportProOnly': 'Экспорт доступен на Pro',
  'catalog.exportFailed': 'Не удалось выгрузить. Попробуйте ещё раз.',
  'catalog.found': 'Найдено {{count}} тендеров',
  'catalog.ikpuLabel': 'Код товара',
  'catalog.ikpuAll': 'Все категории',
  'catalog.sortLabel': 'Сортировка',
  'catalog.sort.newest': 'Сначала новые',
  'catalog.sort.deadline': 'Скоро дедлайн',
  'catalog.sort.budgetDesc': 'Бюджет: по убыванию',
  'catalog.sort.budgetAsc': 'Бюджет: по возрастанию',
  'catalog.budgetFrom': 'Бюджет, от ({{currency}})',
  'catalog.budgetTo': 'Бюджет, до ({{currency}})',
  'catalog.deadlineFrom': 'Срок, с',
  'catalog.excludeWords': 'Не показывать тендеры со словами',
  'catalog.excludeWordsPlaceholder': 'слова через запятую',
  'catalog.deadlineTo': 'Срок, по',
  'catalog.clearFilters': 'Сбросить фильтры',
  'catalog.moreFilters': 'Ещё фильтры',
  // Tender detail
  'tender.backToIfi': '← Вернуться к проектам МФИ',
  'tender.backToCatalog': '← Вернуться к каталогу',
  'tender.loading': 'Загрузка тендера…',
  'tender.sourceLangNote': 'на языке источника',
  // Текст документов лота распознан моделью со скана (15.10.2026): на пробе 2 из
  // 20 сканов, положенных боком, получили ошибки, по которым участник мог
  // ошибиться. {{original}} — ссылка на блок документации, слово ниже.
  'tender.scanNotice':
    'Распознано со скана документа. Суммы, сроки, адреса и реквизиты сверяйте с {{original}}.',
  'tender.scanNoticeOriginal': 'оригиналом',
  // ⚠️ These two are for a DEFINITIVE 404 only. Everything else — a dropped
  // connection, a 5xx during a deploy — uses the `loadFailed` pair below, which
  // exists because one message for both told a paying reader that a live lot
  // had been deleted (see lib/tender-error.ts).
  'tender.notFound': 'Тендер не найден',
  'tender.notFoundDesc': 'Возможно, он был удалён или ссылка устарела.',
  'tender.loadFailed': 'Не удалось загрузить тендер',
  'tender.loadFailedDesc': 'Проверьте соединение и попробуйте ещё раз.',
  'tender.seoDesc':
    'Тендер «{{title}}» — актуальная госзакупка в {{countryPrep}}. Бюджет, сроки подачи, требования и контакты заказчика — на {{brand}}.',
  'tender.seoDescDefault':
    'Тендеры и госзакупки {{countryGen}}: бюджеты, сроки подачи и контакты заказчиков на {{brand}}.',
  // Deterministic key-facts paragraph (buildTenderFacts) — SEO + page fallback.
  'tender.facts.lead': 'Государственная закупка «{{title}}» в {{countryPrep}}.',
  'tender.facts.region': 'Регион проведения — {{region}}.',
  'tender.facts.budget': 'Начальная (максимальная) сумма — {{budget}} {{currency}}.',
  'tender.facts.category': 'Категория: {{category}}.',
  'tender.facts.deadline': 'Приём заявок до {{deadline}}.',
  'tender.facts.published': 'Опубликовано {{published}}.',
  'tender.facts.docs': 'К закупке приложена тендерная документация ({{count}} файл(ов)).',
  'tender.facts.label': 'Кратко о закупке',
  // Award outcome (winner + final price) — shown once a lot is awarded.
  'tender.outcome.label': 'Итог закупки',
  'tender.outcome.winner': 'Победитель',
  'tender.outcome.winnerContact': 'Контакты победителя',
  // Soft on purpose (owner, 2026-10-07) — see WinnerContactCappedNote. The 200 is
  // WINNER_CONTACT_DAILY_LOTS (server); the button opens COMPANY.telegramUrl.
  'tender.outcome.winnerContactCapped':
    'Ваш лимит на сегодня — 200 компаний — исчерпан. Мы заметили необычную активность. Чтобы снять лимит, напишите в поддержку',
  'tender.outcome.winnerContactCappedTelegram': 'Написать в Telegram',
  // The opt-out / correction link (owner, 2026-10-07) — CompanyDataLink.
  'companyData.link': 'Это ваша компания? Скрыть телефон или исправить данные',
  'support.companyData.topic': 'Тема: данные компании, ИНН {{tin}}',
  'support.companyData.prefill': 'Данные компании ИНН {{tin}}. ',
  'tender.buyer.profileLink': 'Профиль заказчика и все его тендеры →',
  'tender.outcome.finalPrice': 'Итоговая цена',
  'tender.outcome.awardedAt': 'Дата решения',
  // 'failed' outcome (goszakup «Информация о победителях») — a lot the
  // source itself marked as not awarded, distinct from an ordinary lot that
  // simply expired with no recorded outcome yet.
  'tender.outcome.failed': 'Закупка не состоялась',
  // The outcome wall (2026-10-07): a guest / free account learns THAT the lot
  // was awarded, not who won or for how much. `lockedRow` is the /results card.
  'tender.outcome.locked': 'Победитель выбран. Имя, сумма и контакт — в Pro',
  'tender.outcome.lockedCta': 'Оформить Pro',
  // Which of the four walls/chips a lot gets is `outcomeLockText` (lib/outcome-lock-text.ts):
  // the API says whether a differing final price and a winner contact exist.
  'tender.outcome.lockedContactOnly': 'Победитель выбран. Имя и контакт — в Pro',
  'tender.outcome.lockedPriceOnly': 'Победитель выбран. Имя и сумма — в Pro',
  'tender.outcome.lockedWhoOnly': 'Победитель выбран. Имя — в Pro',
  'tender.outcome.lockedRow': 'Победитель, сумма и контакт — в Pro',
  'tender.outcome.lockedRowContact': 'Победитель и его контакт — в Pro',
  'tender.outcome.lockedRowPrice': 'Победитель и сумма — в Pro',
  'tender.outcome.lockedRowWho': 'Победитель — в Pro',
  // Sibling lots of the same KZ procurement announcement/batch (goszakup/
  // mitwork/skpharmacy split one purchase into dozens of single-product
  // lots) — see CatalogService.resolveSiblingLots.
  'tender.nav.siblings': 'Другие лоты',
  // Heading as a sentence (2026-10-15): what the list is and that a bid may go
  // to any lot of it. {{lots}} is `lotsWord` (лот / лота / лотов); {{amount}} is
  // the compact sum with its unit.
  'tender.siblings.headline': 'В этом же объявлении ещё {{count}} {{lots}} на {{amount}}',
  'tender.siblings.headlineNoSum': 'В этом же объявлении ещё {{count}} {{lots}}',
  'tender.siblings.hint': 'Заявку можно подать на любые из них — на каждый лот отдельно.',
  'tender.siblings.more': '+{{count}} ещё',
  'tender.contactInfo': 'Контактная информация',
  'tender.contactDetails': 'Контактные данные доступны зарегистрированным пользователям.',
  'tender.contactDetailsAuthed': 'Откройте, чтобы увидеть контакты заказчика.',
  'tender.opening': 'Открываем…',
  'tender.contactName': 'Контактное лицо',
  'tender.contactEmail': 'Email',
  'tender.contactPhone': 'Телефон',
  'tender.contactCategory': 'Вид деятельности',
  'tender.contactWebsite': 'Сайт',
  'tender.contactTelegram': 'Telegram',
  'tender.contactMapAddress': 'Адрес на карте',
  'tender.sourceLabel': 'Первоисточник',
  'tender.openOriginal': 'Открыть оригинал тендера',
  'tender.participateHint': 'Как подать заявку и получить ЭЦП',
  // Supply-scope (cooperation.uz) lots — the ONE, Pro-gated action; same label
  // whether the CTA is locked (→ /plans) or the real outbound link (Pro).
  'tender.openOriginalCoop': 'Открыть оригинал на cooperation.uz',
  'tender.documentsLabel': 'Тендерная документация',
  'tender.docsTeaser.tz': 'Техническое задание',
  'tender.docsTeaser.contract': 'Проект договора',
  'tender.docsTeaser.spec': 'Спецификация',
  'tender.docsTeaser.cta': 'Разблокировать документы',
  // ИП (metered): the padlock offers the open, not Pro — see LockedDocumentsCard.
  'tender.docsTeaser.meteredCta': 'Документы на площадке — открыть ссылку (1 из {{count}})',
  'tender.docsTeaser.meteredHint':
    'Файлы лежат на площадке. Открытие даёт ссылку на оригинал и контакты заказчика — то же действие, что кнопка ниже.',
  'tender.docsTeaser.meteredOpenedCta': 'Документы на площадке — открыть оригинал',
  'tender.procedureLabel': 'Порядок проведения',
  'tender.procedure.method': 'Тип процедуры',
  'tender.procedure.obligationTerm': 'Срок выполнения обязательств',
  'tender.procedure.serviceType': 'Вид работ',
  'tender.procedure.financialSource': 'Источник финансирования',
  'tender.procedure.address': 'Адрес',
  'tender.procedure.deliveryAddress': 'Адрес поставки',
  'tender.procedure.decree': 'Основание',
  'tender.procedure.discussionStart': 'Начало обсуждения',
  'tender.procedure.discussionEnd': 'Окончание обсуждения',
  'tender.procedure.published': 'Дата публикации',
  'tender.procedure.positions': 'Позиций',
  'tender.procedure.positionsHint':
    'Сколько разных товаров, работ или услуг в этом лоте. Заказчик покупает их одной закупкой, заявка подаётся на весь лот.',
  'tender.procedure.docsDeadline': 'Срок вопросов и возражений',
  'tender.procedure.opening': 'Дата вскрытия предложений',
  'tender.procedure.announcementName': 'Объявление',
  'tender.procedure.announcementNumber': 'Номер объявления',
  'tender.procedure.subjectKind': 'Вид предмета закупок',
  'tender.procedure.planType': 'Тип пункта плана',
  'tender.procedure.organizer': 'Организатор',
  'tender.procedure.representative': 'Представитель заказчика',
  'tender.procedure.bidStart': 'Начало приема заявок',
  'tender.procedure.vatNote': 'Признаки',
  'tender.procedure.commission': 'Конкурсная комиссия',
  'tender.contactNone': 'Контактные данные для этого тендера не указаны.',
  'tender.insufficientAllowance': 'Открытия контактов закончились. Обновите тариф или докупите.',
  'tender.nicheRequired': 'Контакты заказчиков доступны на тарифе Pro.',
  'tender.proRequired':
    'Этот тендер вне вашей ниши. Перейдите на Pro, чтобы открывать контакты по всем тендерам.',
  'tender.revealError': 'Не удалось открыть контакт. Попробуйте позже.',
  'tender.upgradeCta': 'Смотреть тарифы',
  // Region
  'region.backToCatalog': '← Вернуться к каталогу',
  'region.title': 'Тендеры в {{region}}',
  'region.loading': 'Загрузка…',
  'region.found': 'Найдено {{count}} тендеров',
  'region.seoTitle': 'Тендеры и госзакупки в {{region}}',
  // Paged variants use the SHORT phrasing ('Тендеры в X'), not the page-1 one: with
  // the " — {{brand}}" suffix the long form plus "— страница N" lands at ~77 chars,
  // so Google truncates the page number away and every page in the series looks
  // identical again — which is the exact bug these keys exist to fix.
  'region.seoTitlePaged': 'Тендеры в {{region}} — страница {{page}}',
  'region.seoDesc':
    'Актуальные тендеры и госзакупки в {{region}}: {{count}} активных. Бюджеты, сроки подачи и контакты заказчиков — на {{brand}}.',
  'region.seoDescPaged':
    'Тендеры и госзакупки в {{region}} — страница {{page}} из {{totalPages}}, всего {{count}} активных. Бюджеты, сроки подачи и заказчики — на {{brand}}.',
  'region.intro':
    'Государственные тендеры и закупки в {{region}}: сейчас {{count}} активных. По каждому доступны бюджет, срок подачи заявок и краткое описание на русском и узбекском. Фильтруйте по категории, сохраняйте поиск и получайте новые тендеры в Telegram.',
  // Category
  'category.backToCatalog': '← Вернуться к каталогу',
  'category.title': 'Тендеры: {{category}}',
  'category.loading': 'Загрузка…',
  'category.found': 'Найдено {{count}} тендеров',
  'category.topBuyers': 'Топ-заказчики в этой категории',
  'category.seoTitle': 'Тендеры и закупки: {{category}}',
  'category.seoTitlePaged': 'Тендеры: {{category}} — страница {{page}}',
  'category.seoDesc':
    'Тендеры и госзакупки по направлению «{{category}}» в {{countryPrep}}: {{count}} активных. Бюджеты, сроки и заказчики — на {{brand}}.',
  'category.seoDescPaged':
    'Тендеры по направлению «{{category}}» в {{countryPrep}} — страница {{page}} из {{totalPages}}, всего {{count}} активных. Бюджеты, сроки и заказчики — на {{brand}}.',
  'category.intro':
    '«{{category}}» — одно из направлений государственных закупок в {{countryPrep}}. Сейчас в каталоге {{count}} актуальных тендеров этой категории: по каждому указаны начальная сумма, срок подачи заявок и краткое описание на русском и узбекском. Уточните регион в каталоге, сохраните поиск и получайте новые закупки в Telegram.',
  // Guide
  'guide.backToCatalog': '← Вернуться к каталогу',
  'guide.seriesHeading': 'Тендер без брокера: пошагово',
  'guide.articlesHeading': 'Статьи по теме',
  'guide.nicheGuidesHeading': 'Гиды по нишам',
  'guide.answersHeading': 'Короткие ответы',
  // Article footer: a SELECTION of siblings, so a different heading from the
  // hub's complete list, plus the way back to that complete list.
  'guide.relatedHeading': 'Ещё по теме',
  'guide.allArticles': 'Все статьи гида',
  // Login
  'login.title': 'Войти',
  'login.subtitle': 'Добро пожаловать в {{brand}}.',
  'checkout.identify.emailHint': 'На него придёт доступ к подписке.',
  // Опечатка в домене: предложение ЗАМЕНЯЕТ общее сообщение, а не добавляется
  // к нему — на экране 360×365 с клавиатурой помещается ровно одна строка.
  'checkout.identify.didYouMean': 'Вы имели в виду {{email}}?',
  // Появляется со ВТОРОГО подряд отказа: одному промаху пример не нужен.
  'checkout.identify.emailExample': 'Например: ism@gmail.com',
  'login.telegramWhy': 'Быстрый вход через Telegram — как при регистрации.',
  'login.email': 'Email',
  'login.password': 'Пароль',
  'login.signingIn': 'Вход…',
  'login.signIn': 'Войти',
  'login.continue': 'Продолжить',
  'login.codeTitle': 'Введите код',
  // Under the code field — which step 1 shows ONLY when the letter's deep link
  // arrived carrying a code (2026-09-21). It says where the digits in the box
  // came from; a pre-filled field nobody typed into otherwise reads as a bug.
  'login.codePrefilled': 'Код из письма подставлен',
  'login.subtitleFor': 'Вход в аккаунт',
  'login.or': 'или',
  'login.noAccount': 'Нет аккаунта?',
  'login.signUp': 'Создать аккаунт',
  // Register
  'register.title': 'Регистрация',
  'register.subtitle': 'Создайте аккаунт в {{brand}}.',
  // Строка на /login и /register, когда туда привела кнопка тарифа: что
  // покупается и почём. {{unit}} — знак валюты рядом с числом (₸ / сум).
  // kaztender.com, 16.10: «Войти / Добро пожаловать» ничего не говорил о тарифе.
  'auth.chosenPlan.month': 'Тариф {{plan}} — {{price}} {{unit}} в месяц',
  'auth.chosenPlan.year': 'Тариф {{plan}} — {{price}} {{unit}} в год',
  // «Сохранить поиск» → /register: какой поиск сохранится после регистрации.
  'register.pendingSearch': 'После регистрации сохраним поиск «{{name}}»',
  'register.name': 'Имя',
  'register.phone': 'Телефон',
  'register.phonePlaceholder': '+998 90 123 45 67',
  'register.phoneInvalid': 'Введите корректный номер, например +998 90 123 45 67',
  'register.emailRequired': 'Введите email',
  'register.codeIncomplete': 'Введите код из 6 цифр',
  'register.tin': '{{tin}}',
  'register.tinOptional': 'Необязательно',
  'register.tinHint': '{{tinDigits}} цифр — покажем ваши выигранные тендеры (необязательно)',
  'register.tinInvalid': '{{tin}} должен содержать ровно {{tinDigits}} цифр',
  'register.email': 'Email',
  'register.sendCode': 'Получить код',
  'register.sendingCode': 'Отправляем…',
  'register.codeSentTo': 'Мы отправили код на',
  'register.code': 'Код из письма',
  'register.codeHint': 'Код действует 10 минут. Не пришёл — проверьте «Спам».',
  'auth.otp.resend': 'Отправить код ещё раз',
  'auth.otp.resendIn': 'Отправить код ещё раз можно через {{seconds}} сек.',
  'auth.otp.notArrived': 'Письмо с кодом не пришло?',
  // 22.10: the server refused to mail a code (5 per address per 15 min).
  'auth.otp.notSentTo': 'Новый код не отправлен на',
  'auth.otp.rateLimited':
    'Слишком много запросов кода. Подождите {{minutes}} мин. или войдите по ссылке из последнего письма.',
  'register.emailDidYouMean': 'Вы имели в виду',
  'register.icloudSpam':
    'Почта iCloud часто отправляет наши письма в «Спам» — проверьте папку. Или войдите через Telegram выше — это быстрее.',
  'register.changeEmail': 'Указать другой адрес',
  'register.editEmail': 'Изменить',
  'register.telegramWhy': 'Уведомления о тендерах приходят в Telegram — так они подключатся сразу.',

  'register.password': 'Пароль',
  'register.passwordHint': 'Минимум 8 символов',
  'register.creating': 'Создание…',
  'register.createAccount': 'Создать аккаунт',
  'register.haveAccount': 'Уже есть аккаунт?',
  'register.signIn': 'Войти',
  'auth.error.emailTaken': 'Этот email уже зарегистрирован. Войдите в аккаунт.',
  'auth.error.invalidCredentials': 'Неверный email или пароль.',
  'auth.error.generic': 'Что-то пошло не так. Попробуйте ещё раз.',
  // Адрес без точки в домене или с однобуквенным TLD («ivan@gmail»,
  // «ivan@gmail.c»): сервер отвечает 400 validation_error, а <input type=email>
  // такое пропускает — по HTML-спеке «a@b» валидно. Раньше показывали
  // auth.error.generic, то есть винили себя и не давали что исправить.
  // Называем ЧТО не так и приводим пример, а не пересказываем правило.
  'auth.error.emailSyntax':
    'Проверьте адрес почты — похоже, в нём опечатка (например, нет .com или .ru)',
  'onboarding.banner.title': 'Настройка профиля: {{done}} из {{total}}',
  // Phone wording (< sm) — same facts, fits one line at 360 px (2026-10-06).
  'onboarding.banner.titleShort': 'Профиль: {{done}} из {{total}}',
  'onboarding.banner.show': 'Показать',
  'onboarding.banner.hide': 'Скрыть',
  'onboarding.banner.go': 'Подключить',
  'onboarding.banner.search': 'Сохранённый поиск',
  'onboarding.banner.telegram': 'Оповещения',
  'onboarding.banner.inn': '{{tin}} компании',
  'onboarding.banner.email': 'Подтвердить почту',
  'onboarding.banner.activate': 'Указать',
  'onboarding.banner.noInn': 'Позже',
  // Строка под строкой «Подтвердить почту» в полоске онбординга: подтверждение
  // ничего не открывает, поэтому оно должно само объяснять, зачем его делать.
  'onboarding.banner.emailWhy':
    'Подтвердите почту — так вы защитите аккаунт и будете получать уведомления о новых тендерах',
  'onboarding.banner.emailWhyShort': 'Чтобы подборки приходили на почту.',
  'onboarding.verifyEmail.send': 'Отправить код',
  'onboarding.verifyEmail.verify': 'Подтвердить',
  // Владелец, 18.10: одно поле «название или ИНН» — на телефоне ИНН под рукой нет.
  'onboarding.inn.title': 'Название или {{tin}} вашей организации?',
  'onboarding.inn.subtitle':
    'Покажем, что ваша компания уже выигрывала и сколько тендеров сейчас открыто в вашей отрасли.',
  'onboarding.inn.skip': 'Пропустить',
  // Под полем, пока номер набран не до конца.
  'onboarding.inn.digitsHint': 'Нужно ровно {{digits}} цифр',
  'onboarding.inn.next': 'Далее',
  'auth.error.passwordRequired': 'Введите пароль',
  // «Неверный код» alone sent people back to re-reading the digits, which is the
  // one thing that cannot help when the code is simply dead: it expires in 10
  // minutes, and ANY newer send consumes it. Both of those look identical to a
  // typo from the outside, so the message has to name them and point at the fix.
  'auth.error.invalidCode':
    'Код не подошёл: возможно, он устарел или его заменил более новый. Запросите новый код.',
  'auth.error.invalidPhone': 'Проверьте номер телефона.',
  // Dashboard
  'dashboard.title': '{{brand}} — панель управления',
  'dashboard.signedInAs': 'Вы вошли как {{email}}.',
  'dashboard.signOut': 'Выйти',
  // SEO
  'seo.landing.title': '{{brand}} — Найдите деловые возможности',
  'seo.landing.description': 'Просматривайте государственные тендеры по всей стране.',
  'seo.catalog.title': 'Тендеры и госзакупки {{countryGen}}',
  'seo.catalog.description':
    'Каталог государственных тендеров и госзакупок {{countryGen}}: актуальные закупки, краткие описания на русском и узбекском, фильтры по региону и категории, оповещения в Telegram — на {{brand}}.',
  // Страница N листинга. Отдельный title обязателен: без него каждая страница
  // пагинации получила бы один и тот же заголовок, и Google схлопнул бы их как
  // дубликаты — а они существуют ровно затем, чтобы дать глубине каталога
  // внутренние ссылки.
  'seo.catalog.titlePaged': 'Тендеры и госзакупки {{countryGen}} — страница {{page}}',
  'seo.results.title': 'Результаты тендеров {{countryGen}}: победители и цены',
  'seo.results.titlePaged': 'Результаты тендеров {{countryGen}} — страница {{page}}',
  // Since the outcome wall (2026-10-07) the winner, the price and the contact
  // are Pro — the description must not promise «кто победил, по какой цене»
  // to everyone (owner, 2026-10-07). <title> is kept.
  'seo.results.description':
    'Завершённые закупки {{countryGen}} с выбранным победителем. Победитель, сумма и контакты — в Pro; фильтры и сохранение поиска — бесплатно.',
  'results.page.h1': 'Результаты тендеров',
  'results.page.intro': 'Завершённые закупки за последний месяц: кто победил и за сколько.',
  // ── /results card «Что вы поставляете?» (feat/results-search, 2026-10-07) ──
  'results.card.title': 'Что вы поставляете?',
  'results.card.sub': 'Покажем, кто выиграл такие закупки.',
  'results.card.placeholder': 'рис, мука, насосы…',
  'results.card.inputLabel': 'Слова, категории и коды ЕНКТ',
  'results.card.remove': 'Убрать «{{label}}»',
  'results.card.category': 'Категория:',
  'results.card.ikpu': 'ЕНКТ',
  'results.suggest.word': 'Слово:',
  'results.suggest.wordHint': 'в названии и описании',
  'results.suggest.foot': '↵ — добавить как слово · категория точнее, слово шире',
  'results.refine': 'Уточнить',
  'results.refine.empty': 'регион · сумма · исключения',
  'results.refine.region': 'Регион',
  'results.refine.addRegion': '+ регион',
  'results.refine.sum': 'Сумма лота, {{currency}}',
  'results.refine.from': 'от',
  'results.refine.to': 'до',
  'results.refine.any': 'любая',
  'results.refine.sumFrom': 'от {{amount}}',
  'results.refine.sumTo': 'до {{amount}}',
  'results.refine.exclude': 'Не присылать со словами',
  'results.refine.excludePlaceholder': 'слово…',
  'results.refine.excludeCount': 'без {{count}} сл.',
  'results.refine.kind': 'Тип закупки',
  'results.refine.customer': 'Заказчик',
  'results.refine.customerLabel': '{{tin}} заказчика',
  'results.kind.goods': 'Товары',
  'results.kind.works': 'Работы',
  'results.kind.services': 'Услуги',
  'results.count.found': 'Найдено {{count}} {{word}}',
  'results.count.period': 'за месяц',
  'results.count.week': '{{count}} за неделю',
  'results.count.today': '{{count}} сегодня',
  'results.count.loading': 'Считаем результаты…',
  'results.save': 'Сохранить поиск',
  'results.update': 'Обновить поиск',
  'results.saved': 'Поиск сохранён',
  'results.save.empty': 'Добавьте слово — и поиск можно сохранить',
  'results.save.guest': 'Бесплатно — понадобится регистрация',
  'results.save.note': 'Один поиск результатов на аккаунт — новое сохранение обновит его',
  'results.save.error': 'Не удалось сохранить поиск. Попробуйте ещё раз',
  'results.changed': 'Изменено: {{list}} — обновите поиск, чтобы сохранить',
  'results.updated': 'Обновлено: {{list}}',
  'results.created': 'Сохранено. Оповещения о новых результатах — в настройках оповещений',
  'results.change.region': 'регион',
  'results.change.budget': 'сумма',
  'results.change.exclude': 'исключения',
  'results.change.kind': 'тип закупки',
  'results.change.customer': 'заказчик',
  'results.change.text': 'слова',
  'results.change.category': 'категории',
  'results.change.ikpu': 'коды ЕНКТ',
  'results.change.name': 'название',
  'results.wall.line': 'Контакты, ИНН и суммы победителей — в Pro',
  'results.wall.cta': 'Оформить Pro',
  // The results search's fixed name — the alert-settings row label (owner, 2026-10-07).
  'savedSearches.results.name': 'Результаты',
  'savedSearches.results.hint': 'Оповещение, когда по похожей закупке выбрали победителя',
  'savedSearches.results.edit': 'Изменить на странице результатов',
  // ── m16 app shell ──────────────────────────────────────────────
  'shell.search.placeholder': 'Поиск тендеров по смыслу…',
  'shell.search.ai': 'AI',
  'shell.section.catalog': 'Каталог',
  'shell.section.regions': 'Регионы',
  'shell.section.categories': 'Категории',
  'shell.showAll': 'Показать все ({{count}})',
  'shell.showLess': 'Свернуть',
  'shell.section.savedSearches': 'Сохранённые поиски',
  'shell.saved.guestCta': 'Сохранить свой поиск',
  'shell.nav.allTenders': 'Все тендеры',
  'shell.nav.ifiProjects': 'Проекты МФИ',
  'shell.nav.supplyRequests': 'Кооперация',
  'shell.nav.favorites': 'Избранное',
  'favorites.title': 'Избранное',
  'favorites.subtitle': 'Тендеры, которые вы сохранили, чтобы вернуться к ним позже.',
  'favorites.empty.title': 'Здесь пока пусто',
  'favorites.empty.desc': 'Нажимайте ☆ на карточке тендера, чтобы добавить его в избранное.',
  'favorites.empty.cta': 'Перейти к каталогу',

  // ── «Мои тендеры» (/app/my-tenders) ───────────────────────────────────────
  // Всё, что подошло под сохранённые поиски, включая матчи, срезанные потолком
  // дайджеста (73,8% у платящих на 13.09.2026). Страница появляется только при
  // двух и более активных поисках.
  'myTenders.title': 'Мои тендеры',
  'myTenders.subtitle': 'Все тендеры, которые подходят под ваши сохранённые поиски, новые сверху',
  'myTenders.chip.all': 'Все',
  'myTenders.showClosed': 'Показать закрывшиеся',
  'myTenders.total': 'Всего: {{count}}',
  'myTenders.bySearch': 'по поиску: {{names}}',
  'myTenders.new': 'новое',
  // Доступное имя всей строки сайдбара, пока виден бейдж. Сам бейдж
  // aria-hidden: «5», прочитанная отдельно, не значит ничего.
  'myTenders.newCountAria': 'Мои тендеры, новых совпадений: {{count}}',
  'myTenders.empty.title': 'Пока ничего не подошло',
  'myTenders.empty.descOpen':
    'По вашим поискам нет открытых тендеров. Включите «Показать закрывшиеся» или измените поиск на странице «Оповещения».',
  'myTenders.empty.desc':
    'По вашим поискам пока нет ни одного тендера. Измените условия на странице «Оповещения».',
  'shell.nav.alerts': 'Оповещения',
  'shell.nav.menu': 'Меню',
  'shell.nav.menu.a11yDesc': 'Разделы сайта, сохранённые поиски и настройки аккаунта.',
  'shell.nav.openMenu': 'Открыть меню',
  'shell.nav.closeMenu': 'Закрыть меню',
  'shell.saved.empty': 'Пока нет сохранённых поисков',
  'catalog.saveSearch': 'Сохранить поиск',
  // Кнопка гостя ведёт на регистрацию, а не на вход — «войдите» было неправдой.
  'catalog.saveSearchGuest':
    'Зарегистрируйтесь бесплатно — поиск сохранится, и мы пришлём новые тендеры',
  // Видимая строка под серой кнопкой: на телефоне title-подсказки не видно,
  // и кнопка молчала (kaztender.com, 16.10).
  'catalog.saveSearchPickFirst': 'Сначала выберите категорию',
  'saved.close': 'Закрыть',

  // ── «Сохранённые поиски» на /app/alerts ───────────────────────────────────
  'savedSearches.title': 'Сохранённые поиски',
  'savedSearches.edit': 'Редактировать',
  'savedSearches.summary.from': 'от {{amount}}',
  'savedSearches.summary.to': 'до {{amount}}',
  'savedSearches.summary.except': 'кроме: {{terms}}',
  'savedSearches.rate': '≈ {{count}} лотов в день',
  // ⚠️ Не «0 в день». Ноль читается как «поиск ничего не находит» — а на деле
  // мы просто ещё не измерили: рейт появляется после недели истории.
  'savedSearches.rate.unknown': 'мало данных',
  // Пояснение к «мало данных» той же строкой — что это не «ноль лотов».
  'savedSearches.rate.unknownHint': 'частоту покажем, когда у поиска наберётся неделя истории',
  'savedSearches.delete.title': 'Удалить поиск',
  'savedSearches.delete.confirm':
    'Удалить поиск «{{name}}»? Уведомления по нему перестанут приходить.',
  'savedSearches.instant': 'Присылать сразу',
  // Не повторять «сразу» из названия тумблера: подсказка объясняет, ЧТО меняется
  // (отдельное сообщение вместо ожидания дайджеста) и при каких условиях.
  'savedSearches.instant.hint':
    'Каждый новый лот — отдельным сообщением, без ожидания дайджеста. Только для точных поисков (до 3 лотов в день); не больше 5 сообщений в час.',
  'savedSearches.instant.no.broad': 'Только для поисков с уточнением (слово, ЕНКТ, регион, ниша…)',
  'savedSearches.instant.no.rate':
    'Этот поиск даёт ≈{{count}} в день — слишком много для отдельных сообщений',
  // С 13.09 «young» — редкость: у нового поиска частота оценивается по каталогу
  // сразу. Остаётся только случай, когда оценка не удалась.
  'savedSearches.instant.no.young': 'Не удалось оценить частоту — попробуйте позже',
  'savedSearches.instant.no.plan': 'Доступно на Pro',
  'savedSearches.instant.rejected':
    'Не удалось изменить: поиск больше не подходит для отдельных сообщений. Обновите страницу.',
  'saved.deleteYes': 'Да',
  'saved.delete': 'Удалить',
  'saved.edit': 'Изменить',
  'saved.matches': 'Сейчас подходит тендеров: {{n}}',
  'saved.rate': '≈{{n}} в неделю по этому фильтру',
  'saved.minBudgetLabel': 'Бюджет от, {{currency}}',
  'saved.minBudgetPlaceholder': '500 000 000',
  'saved.maxBudgetLabel': 'Бюджет до, {{currency}}',
  'saved.maxBudgetPlaceholder': '1 000 000 000',
  'saved.budgetRangeError': 'Бюджет «до» не может быть меньше «от».',
  'saved.learnedLabel': 'Исключено по вашим отметкам 👎 (нажмите, чтобы вернуть)',
  'saved.learnedRemove': 'Вернуть',
  'saved.excludeTermsLabel': 'Не присылать тендеры со словами',
  'saved.excludeTermsPlaceholder': 'слова через запятую',
  'saved.excludeTermsHint': 'Тендер с любым из этих слов не попадёт в оповещения.',
  'tagInput.remove': 'Убрать «{{term}}»',
  'tagInput.max': 'Максимум {{count}}',
  'tagInput.tooLong':
    'Слишком длинно: {{count}} символов, можно до {{max}}. Сократите до одного-двух слов.',
  'saved.matchesNone':
    'Сейчас по этим фильтрам нет открытых тендеров — оповещений не будет, пока не появится подходящий. Попробуйте расширить фильтр.',
  'saved.nameLabel': 'Название',
  'saved.defaultName': 'Мой поиск',
  'saved.save': 'Сохранить',
  'saved.cancel': 'Отмена',
  'saved.edit.title': 'Настроить поиск',
  'saved.edit.a11yDesc': 'Название, категории, исключения и минимальный бюджет подписки.',
  'saved.edit.saving': 'Сохраняем…',
  'saved.edit.error': 'Не удалось сохранить',
  'saved.edit.errorSubject': 'Оставьте хотя бы одно: категорию, ЕНКТ, нишу, заказчика или слово.',
  'saved.edit.errorInvalid': 'Не получилось сохранить: проверьте поля и попробуйте ещё раз.',
  'saved.edit.errorTerms':
    'Слишком много слов или слово слишком длинное. Уберите лишние и сохраните ещё раз.',
  'saved.saved': 'Сохранено',
  'saved.toast': 'Поиск сохранён',
  'saved.tender.add': 'В избранное',
  'saved.tender.remove': 'Убрать из избранного',
  'saved.limitReached':
    'На бесплатном тарифе — не больше {{n}} сохранённых поисков. Оформите Pro для неограниченного числа.',
  'saved.errorGeneric': 'Не удалось сохранить поиск. Попробуйте ещё раз.',
  'saved.emptyCriteria':
    'Добавьте хотя бы один фильтр — категорию, регион, ключевое слово или бюджет.',
  'alert.picker.title': 'Какое оповещение настроить?',
  'alert.picker.createNew': 'Создать новое',
  'saved.tuneAlert': 'Настроить оповещения',
  'saved.deleteAlert': 'Удалить оповещение',
  'saved.deleteConfirm': 'Да, удалить',
  'saved.deleteWarning':
    'Уведомления по этому поиску перестанут приходить. Создать новое можно из каталога.',
  'shell.user.signIn': 'Войти',
  'shell.user.guest': 'Гость',
  'shell.user.notSignedIn': 'Вы не вошли',
  'shell.user.freePlan': 'Бесплатный тариф',
  'shell.user.paidPlan': 'Тариф {{plan}}',
  'shell.upgrade.label': 'Перейти на Pro',
  'shell.upgrade.desc': 'Откройте контакты заказчиков, документы и аналитику',
  // ── Connect Telegram for alerts ──────────────────────────────────
  'telegram.connect.title': 'Подключите Telegram для уведомлений',
  'telegram.connect.desc':
    'Получайте новые тендеры по вашей нише прямо в Telegram. Нажмите кнопку ниже и разрешите боту писать вам.',
  'telegram.connect.benefit1': 'Мгновенные алерты по сохранённым поискам',
  'telegram.connect.benefit2': 'Уведомления о подходящих тендерах для поставщиков',
  // Надпись на НАШЕЙ кнопке подключения — ОДНА на все четыре поверхности
  // (полоска онбординга, модалка, карточка кабинета, баннер каталога). С 18.10
  // кнопка ведёт в бота, как вход (виджета telegram.org на сайте больше нет).
  // Два слова — полоска онбординга узкая.
  'telegram.connect.cta': 'Подключить Telegram',
  // «Войти через Telegram» / «Подключить Telegram» ЧЕРЕЗ БОТА — с 18.10
  // единственная дверь Telegram на сайте (решение владельца). Кнопка ведёт в
  // бота; нажатие Start в боте И ЕСТЬ вход (или привязка): страница ждёт и
  // входит сама, а бот присылает «Готово, …!».
  'telegram.bot.cta': 'Войти через Telegram',
  'telegram.bot.waiting': 'Нажмите Start в Telegram — вход произойдёт сам',
  'telegram.bot.waitingConnect': 'Нажмите Start в Telegram — он подключится сам',
  // На компьютере ссылка открывает Telegram Desktop или Telegram Web в новой
  // вкладке; рядом — обратный отсчёт до конца 15 минут.
  'telegram.bot.waitingDesktop': 'Откройте Telegram и нажмите Start. Ждём…',
  'telegram.bot.reopen': 'Открыть Telegram ещё раз',
  // Через ~2 с после нажатия, если страница всё ещё на экране (только /login и
  // /register): встроенный браузер Instagram/Facebook мог не отдать ссылку
  // приложению. {{app}} — Instagram или Facebook.
  'telegram.bot.inAppHint':
    'Не открылся Telegram? В {{app}} нажмите ⋯ вверху справа → «Открыть в браузере».',
  'telegram.bot.notOpenedHint': 'Не открылся Telegram? Скопируйте ссылку и откройте её в браузере.',
  'telegram.bot.copyLink': 'Скопировать ссылку',
  'telegram.bot.copied': 'Ссылка скопирована',
  'telegram.bot.expired': 'Не получилось — нажмите ещё раз.',
  'telegram.bot.connected': 'Telegram подключён',
  'telegram.bot.failed': 'Не удалось подготовить вход через Telegram. Нажмите кнопку ещё раз.',
  // /auth/tg/<код> — одноразовая ссылка из бота («Перейти на сайт и настроить
  // уведомления»): входит в тот браузер, который её открыл.
  'telegram.magic.signingIn': 'Входим…',
  'telegram.magic.expired':
    'Ссылка для входа устарела или уже использована. Войдите через Telegram ещё раз — это одна кнопка.',
  'telegram.magic.toLogin': 'Войти',
  'telegram.magic.toSite': 'Перейти на сайт',
  // С 18.10 (проверка безопасности) ссылка НЕ входит сама при открытии: гость
  // видит «Войти как {имя}?» и входит кнопкой; браузер, где вошли в ДРУГОЙ
  // аккаунт, видит «Эта ссылка для другого аккаунта», и ничего не меняется.
  'telegram.magic.checking': 'Проверяем ссылку…',
  'telegram.magic.confirmAs': 'Войти как {{name}}?',
  'telegram.magic.confirm': 'Войти через Telegram?',
  'telegram.magic.confirmHint':
    'Вход по ссылке из нашего Telegram-бота. Если это не ваш Telegram, нажмите «Это не я».',
  'telegram.magic.signIn': 'Войти',
  'telegram.magic.notMe': 'Это не я',
  'telegram.magic.linking': 'Подключаем Telegram…',
  'telegram.magic.mismatch':
    'Эта ссылка для другого аккаунта. Вы вошли на сайт под своим — в нём ничего не изменилось.',
  'telegram.connect.mismatch':
    'Этот вход через Telegram начат из другого аккаунта — ничего не изменилось. Нажмите кнопку ещё раз.',
  'telegram.connect.error': 'Не удалось подключить Telegram. Попробуйте ещё раз.',
  'telegram.connect.taken':
    'Этот Telegram уже привязан к другому аккаунту {{brand}}. Войдите в этот аккаунт или сначала отвяжите Telegram от него. Чтобы сменить аккаунт Telegram, нажмите «Выйти» в самой кнопке Telegram (на ней показано имя вошедшего) и войдите под своим.',
  'telegram.connect.hasTeam':
    'Этот Telegram уже привязан к аккаунту, который состоит в команде. Такой аккаунт нельзя объединить автоматически — напишите на {{brandEmail}}.',
  'telegram.connect.hasAssets':
    'Этот Telegram привязан к аккаунту, у которого есть подписка, оплаты или другие собственные данные. Такой аккаунт нельзя объединить автоматически — войдите в него или напишите на {{brandEmail}}.',
  'telegram.status.connected': 'Telegram подключён',
  'telegram.status.desc': 'Оповещения по сохранённым поискам приходят в Telegram.',
  'telegram.disconnect.cta': 'Отключить',
  'telegram.disconnect.pending': 'Отключаем…',
  'telegram.disconnect.confirm':
    'Отключить Telegram? Оповещения перестанут приходить, пока не подключите снова.',
  // ── Tender row / list ──────────────────────────────────────────
  'tender.status.active': 'Активен',
  'tender.publishedShort': 'опубликован',
  // «№ …» in the lot header, Kazakhstan (2026-10-21) — `LotNumberChip`. The
  // label is the button's name; «Скопировано» flashes beside it after a tap.
  'tender.number.copyLabel': 'Номер объявления {{number}} — скопировать',
  'tender.number.copied': 'Скопировано',
  'tender.status.closing': 'Скоро закрытие',
  'tender.status.closed': 'Завершён',
  'tender.ai': 'AI',
  'tender.budget.unit': '{{currency}}',
  // Читается вслух вместо размытых цифр: сами плейсхолдеры aria-hidden.
  'teaser.srLocked': 'Доступно на Pro',
  // Имя ссылки, накрывающей всю запертую карточку (видимой кнопки нет).
  'teaser.openPlans': '{{card}} — доступно на Pro, посмотреть тарифы',
  'tender.budget.undisclosed': 'Не указан',
  'tender.notice.ifb': 'Приглашение к торгам',
  'tender.notice.reoi': 'Запрос заинтересованности',
  'tender.notice.gpn': 'Общее уведомление',
  'tender.notice.advance': 'Предварительное уведомление',
  'tender.notice.firm': 'Отбор консультантов',
  // «Обеспечение заявки», не просто «Обеспечение» — то же, что и на детальной
  // (tender.overview.bidSecurity). Значение рядом теперь либо сумма, либо
  // ставка в процентах, и голое «Обеспечение: 1» читалось как «1 {{currency}}».
  'tender.bidSecurity': 'Обеспечение заявки',
  'tender.deadline.closes': 'Закрытие',
  'tender.deadline.tba': 'Уточняется',
  // «Анонс» (xt-xarid, 2026-09-29): процедура объявлена, приём заявок ещё не
  // открыт, срока нет — бейдж стоит на месте срока, строка ниже — на странице лота.
  'tender.deadline.announcement': 'Скоро приём заявок',
  'tender.deadline.announcementNote':
    'Это анонс: тендер объявлен и запланирован, приём заявок ещё не открыт. Добавьте его в избранное, чтобы не потерять.',
  'tender.singleSupplier.badge': 'Приглашение одному поставщику',
  'tender.singleSupplier.hint':
    'Из одного источника по несостоявшимся закупкам: заявку подаёт только приглашённый поставщик',
  'tender.singleSupplier.note':
    'Закупка из одного источника по несостоявшимся закупкам: прошлая процедура не состоялась, и заказчик пригласил одного поставщика. Подать заявку может только он. Лот показан, чтобы вы видели спрос заказчика; в уведомления такие лоты не попадают.',
  'tender.bidsOpen.from': 'Приём заявок с {{date}}',
  'tender.similar.title': 'Похожие тендеры',
  // Закрытый лот без итога (аудит ChatGPT-канала 2026-10-08, п. 1): честный
  // статус вместо молчания и выход на живые лоты того же кода ЕНКТ.
  'tender.closedNoOutcome.title': 'Приём заявок завершён {{date}}',
  'tender.closedNoOutcome.titleNoDate': 'Приём заявок завершён',
  'tender.closedNoOutcome.body': 'Итоги пока не опубликованы.',
  'tender.similarLive.title': 'Похожие открытые лоты',
  'tender.similarLive.follow': 'Следить за такими',
  'list.col.tender': 'Тендер',
  'list.col.budget': 'Бюджет',
  'list.col.noticeType': 'Тип извещения',
  'list.col.deadline': 'Срок',
  // Метки для LotCard на лендингах /start и /ip — те же смыслы, что и
  // list.col.*, но своя пара ключей: карточки лендинга не переиспользуют
  // колонки таблицы каталога напрямую, чтобы правка одной не задела другую.
  'landing.lotCard.contactLabel': 'Контакт заказчика',
  'landing.lotCard.lockLabel': 'в Pro',
  'landing.lotCard.activeLabel': 'Активен',
  'landing.lotCard.docsLabel': 'ТЗ и договор',
  // Отдельный ключ, а не переиспользование tender.bidSecurity: узбекский
  // текст в макете лендинга («Ta'minot») отличается от каталожного
  // («Kafillik») — правка одного не должна задеть другой.
  'landing.lotCard.bidSecurityLabel': 'Обеспечение',
  // Шаблон «осталось N дней»: {{word}} — уже согласованная форма (см.
  // daysWord в lib/format.ts), компонент лишь подставляет числа.
  'landing.lotCard.daysLeft': 'осталось {{n}} {{word}}',
  // Пустое состояние вкладки переключателя ниш на /ip: ниша существует, но
  // в её live-выдаче сейчас нет ни одного лота — вместо пустой сетки.
  'landing.nicheSwitcher.emptyLabel':
    'Сейчас в этой нише активных лотов нет — откройте категорию целиком.',
  // Доступная подпись мокапа Telegram-чата в блоке «Что меняет Pro».
  'landing.illustration.chatLabel': 'Пример уведомлений в Telegram',
  // Доступное описание шкалы диапазона цен победителя (панель «Рыночные данные»).
  'landing.illustration.rangeAriaLabel': '{{label}}: от {{min}} до {{max}}, эта позиция — {{pct}}%',
  'search.empty.title': 'Сейчас таких тендеров нет',
  // ⚠️ NO lot count in this string. It read «около 2 400 активных лотов» from
  // launch until 2026-08-13, by which time the live catalogue held 3 160 — a
  // hardcoded number in copy is a permanent staleness liability, and the real
  // count is already on screen in the results summary above the list.
  'search.empty.body':
    'Подходящего лота сейчас в каталоге нет. Подпишитесь — пришлём уведомление в Telegram в день публикации.',
  // ⚠️ NEITHER string may claim there are no matches. «клининг» returns 53 lots
  // — all dragged in by the fallback recall arms, none of them cleaning — so
  // "ничего не найдено" would be false on the very query this feature exists
  // for. Both say what IS true: the query names one of our categories.
  'niche.hint.applied': 'Похоже, вы ищете нишу «{{niche}}» — добавили её лоты в выдачу.',
  'niche.hint.suggest': 'Похоже, вы ищете нишу «{{niche}}».',
  'niche.hint.open': 'Открыть нишу →',
  'niche.hint.ambiguous': 'Возможно, вы ищете одну из ниш:',
  'catalog.lotNumberMatch.one': 'Найден лот № {{n}}',
  'catalog.lotNumberMatch.many': 'Найдены лоты с номером № {{n}}',
  'org.hint.intro': '«{{q}}» — это {{tin}} организации. Открыть её профиль:',
  'org.hint.buyer': '{{name}} — заказчик',
  'org.hint.supplier': '{{name}} — поставщик',
  'list.density.normal': 'Обычный',
  'list.density.compact': 'Компактный',
  'list.empty': 'Нет тендеров, соответствующих текущим фильтрам.',
  // Чип в ☆ Избранном: пакет заявки по этому лоту уже собран, ссылка на DOCX.
  'list.bidPackageReady': 'Заявка готова',
  // Short layer tag on a search-result row (a search spans every layer).
  'ifi.badge': 'МФИ',
  'supply.badge': 'Кооперация',
  'scope.chips.aria': 'Фильтр по разделу каталога',
  'ifi.page.h1': 'Проекты МФИ',
  'ifi.page.intro':
    'Закупки по проектам, финансируемым международными институтами. Заказчик — узбекское ведомство, финансирование банковское, поэтому бюджет публикуется не в сумах, а в валюте проекта.',
  // #52 — «Проекты по ведомствам»
  'ifi.projects.title': 'Проекты по ведомствам',
  'ifi.projects.emptyForSource':
    'Этот институт не публикует исполняющее ведомство — разрез по нему пуст.',
  'ifi.projects.subtitle':
    'Проекты международных институтов в разрезе министерств и ведомств-заказчиков.',
  'ifi.source.aria': 'Институт',
  'ifi.source.all': 'Все',
  'ifi.source.worldbank': 'Всемирный банк',
  'ifi.source.adb': 'АБР',
  'ifi.source.aiib': 'AIIB',
  'ifi.source.undp': 'ПРООН',
  'ifi.source.ungm': 'UNGM',
  'ifi.source.isdb': 'ИБР',
  'ifi.source.ebrd': 'ЕБРР',
  'ifi.source.uzrd': 'UzRD',
  'ifi.source.osce': 'ОБСЕ',
  'ifi.source.ariaLabel': '{{label}}, {{count}} тендеров',
  // Чипы площадок основного каталога — только kaztender.com (`govSources`);
  // на UzTender список площадок пуст и эти строки не рисуются.
  'catalog.source.aria': 'Площадка',
  'catalog.source.all': 'Все',
  'catalog.source.goszakup': 'Госзакупки',
  'catalog.source.samruk': 'Самрук-Казына',
  'catalog.source.mitwork': 'Mitwork',
  'catalog.source.skpharmacy': 'СК-Фармация',
  'catalog.source.medecc': 'Медорганизации',
  'catalog.source.erg': 'ERG',
  'catalog.source.qarmet': 'Qarmet',
  'catalog.source.tizilim': 'Tizilim',
  'catalog.source.ccx': 'Caspy Tender',
  'catalog.source.eurasiantech': 'EurasianTech',
  'catalog.source.etsTender': 'ЕТС-Тендер',
  // Kyrgyzstan's portals (manastender.com `govSources`).
  'catalog.source.kgGoszakupki': 'Госзакупки (новый портал)',
  'catalog.source.kgZakupkiGov': 'zakupki.gov.kg',
  'catalog.source.kgZakupkiOkmot': 'Госкомпании (zakupki.okmot.kg)',
  'catalog.source.ariaLabel': '{{label}}, {{count}} тендеров',
  'ifi.seo.title': 'Тендеры Всемирного банка, ADB и агентств ООН в {{countryPrep}}',
  'ifi.seo.description':
    'Открытые закупки по проектам международных финансовых институтов в {{countryPrep}}: Всемирный банк, АБР, AIIB, агентства ООН. Сроки, документы, требования.',
  // Task 10 — cooperation.uz reverse-auction supply requests: thin, budgetless
  // leads shown as their own opt-in section, deliberately `noindex` (see
  // isTenderIndexable in lib/tender-status.ts).
  // One name for the section everywhere: the sidebar says «Кооперация», so the
  // page does too (the audit found three names for one thing).
  'supply.page.h1': 'Кооперация: запросы предложений',
  'supply.page.intro':
    'Заявки на поставку с торговой площадки cooperation.uz — без объявленного бюджета в сумах, поэтому они вынесены в отдельный раздел и не участвуют в основном каталоге.',
  'supply.seo.title': 'Кооперация: запросы предложений с cooperation.uz',
  'supply.seo.description':
    'Заявки на поставку товаров и услуг с торговой площадки cooperation.uz — без указания бюджета в сумах.',
  // ── Filter bar ─────────────────────────────────────────────────
  'filter.label': 'Фильтр:',
  'filter.region': 'Регион',
  // Buyer (заказчик) subscription axis — active-filter chip label on the
  // catalog, e.g. «Заказчик: ГУП …». Removal reuses `filter.chip.remove`.
  'filter.customer': 'Заказчик',
  'filter.category': 'Категория',
  'filter.ikpu.label': 'Или по коду товара',
  'filter.ikpu.allUnder': 'Все коды {{code}}',
  'filter.ikpu.searchWords': 'Такого кода нет — искать «{{q}}» по словам в лотах',
  'filter.ikpu.noCodeHint':
    'Кода с такими словами нет. Напишите одним словом, что вы поставляете, например «мебель» или «реклама»',
  // Count of a code nested under another code in the same list. ИКПУ counts are
  // hierarchical, so this row's tenders are already inside {{total}} — «4 из 34»
  // says that outright, instead of letting the column look like it should sum.
  'filter.ikpu.countOfParent': '{{n}} из {{total}}',
  // Disclosure toggle on a collapsible ИКПУ section header — the accessible
  // name for the twisty button, distinct from the row's own label (which
  // SELECTS the section rather than expanding it).
  'filter.ikpu.expand': 'Развернуть раздел',
  'filter.ikpu.collapse': 'Свернуть раздел',
  'filter.more.categories': 'Показать ещё {{count}} категорий',
  'filter.chip.remove': 'Убрать: {{name}}',
  'filter.ikpu.pickedInside': 'Внутри выбрано: {{count}}',
  'filter.more.niches': 'Показать ещё {{count}} ниш',
  'filter.more.ikpu': 'Показать ещё коды',
  'filter.status': 'Статус',
  'filter.all': 'Все',
  // The trigger's CALL-TO-ACTION label, shown in place of «Все» only while the
  // activation nudge is on (a new user who hasn't picked a category yet) — «Все»
  // reads as "nothing to do here" and users just scroll; this invites the pick.
  'filter.selectCategory': 'Выбрать категорию',
  'filter.niche': 'Категория или товар',
  'filter.niche.search': 'Поиск: категория или товар…',
  // Screen-reader-only live announcement in the multi-select picker (the
  // checkbox fill/reorder that sighted users see on a pick is otherwise
  // silent to a screen reader).
  'filter.multi.selectedCount': 'Выбрано: {{count}}',
  // Niches (Spec #3 classification layer) shown in the search results, above
  // raw ИКПУ codes — shared between the catalog filter and onboarding.
  'niche.section': 'Ниши',
  'niche.badge': 'ниша',
  'filter.status.active': 'Активные',
  'filter.status.closing': 'Скоро закрытие',
  'filter.status.closed': 'Закрытые',
  'filter.status.all': 'Все',
  'filter.clear': 'Сбросить фильтры',
  'result.count': '{{count}} {{word}}',
  'result.countAtLeast': '{{count}} {{word}}',
  'result.countOf': '{{count}} из {{total}} {{word}}',
  'result.matching': 'по текущим фильтрам',
  // ── "Что означает это число?" — пояснение к счётчику тендеров (#41) ──
  'result.hint.gov':
    'Показаны только открытые госзакупки {{countryGen}} — активные и закрывающиеся. Завершённые и просроченные в счёт не входят. Каталог обновляется автоматически.',
  'result.hint.ifi':
    'Проекты, финансируемые международными институтами (Всемирный банк, АБР и др.). Бюджет в сумах не публикуется, поэтому в счёт входят открытые нотисы без суммы.',
  'result.hint.corporate':
    'Собственные закупки компаний (банки, авиалинии). Показаны только открытые объявления с их порталов.',
  // ── Catalog header stat chips ──────────────────────────────────
  'catalog.chips.active': '{{count}} активных',
  'catalog.chips.closingWeek': '{{count}} скоро закрываются',
  'catalog.chips.newToday': '{{count}} {{word}}',
  // «Ваша подборка» — the catalogue the onboarding sheet closes onto (2026-10-06).
  // {{lots}} is pluralised in code (открытый лот / открытых лота / открытых лотов).
  'catalog.mySelection': 'Ваша подборка: {{count}} {{lots}}',
  // The unfiltered catalogue's first ask — the heading of the highlighted filter card.
  'catalog.spotlight.title': 'Выберите, что вы поставляете — покажем подходящие тендеры',
  'result.updated': 'Обновляется',
  'tgBanner.title': 'Получайте тендеры в Telegram',
  'tgBanner.desc': 'Оповещения по вашим сохранённым поискам',
  'tgBanner.dismiss': 'Скрыть',
  'channelCta.title': 'Крупные тендеры в Telegram',
  'channelCta.desc': 'Победители недели и самые большие лоты — каждый день',
  'channelCta.button': 'Подписаться',
  // ── Pagination ─────────────────────────────────────────────────
  'pagination.showing': 'Показано {{from}}–{{to}} из {{total}}',
  'pagination.prev': 'Назад',
  'pagination.next': 'Вперёд',
  // ── Upgrade banner / plans ─────────────────────────────────────
  'plans.eyebrow': 'Тарифы Pro',
  'plans.title': 'Откройте контакты заказчиков и экспорт данных',
  'plans.subtitle':
    'Доступ к контактам заказчиков, экспорт в Excel, Telegram-оповещения о новых тендерах.',
  'plans.cta': 'Смотреть тарифы',
  'plans.dismiss': 'Позже',
  // ── Plans / pricing page ───────────────────────────────────────
  'plans.pageTitle': 'Тарифы',
  'plans.seoTitle': 'Тарифы и цены — доступ к контактам заказчиков',
  'plans.seoDesc':
    'Тарифы {{brand}}: Pro — 399 000 {{currency}} в месяц: контакты заказчиков, документы тендеров и экспорт данных по госзакупкам {{countryGen}}. Бесплатный доступ к описаниям и требованиям.',
  /* The pricing page's OWN lead. Deliberately not `plans.title`, which is the
     paywall modal's headline — borrowing it left this page with no visible
     heading and a stray grey line, and tied two very different surfaces to one
     sentence. States the real free/paid split: understanding a tender is free,
     acting on it is what the tariff buys. */
  'plans.pageLead':
    'Читать и разбирать тендеры можно бесплатно. Тариф открывает контакты заказчика, документы и аналитику — то, что нужно, чтобы участвовать.',
  'billing.autoRenew.title': 'Автопродление',
  'billing.subscription.title': 'Ваша подписка',
  'billing.autoRenew.card': 'Сохранённая карта: {{pan}}',
  'billing.autoRenew.toggle': 'Продлевать подписку автоматически',
  'billing.autoRenew.note':
    'Списание с сохранённой карты в день окончания периода, без подтверждения. Отключить можно в любой момент.',
  // Retention line under the toggle: what продление keeps running, what you
  // don't re-enter, and what the plan becomes if you switch it off.
  'billing.autoRenew.retention':
    'Пока продление включено, алерты и контакты не прерываются, а карту не нужно вводить заново. Выключить — один клик: тариф станет разовым и закончится {{date}}.',
  // Under the toggle while a pause is scheduled or running (10.10): the
  // charge comes AFTER the pause, and switching renewal off cancels the pause
  // too (server: setAutoRenew) — so «тариф станет разовым и закончится …»
  // would name the wrong date. Replaces both `note` and `retention`.
  'billing.autoRenew.notePaused':
    'Списание {{date}} после паузы, с сохранённой карты. Выключить продление можно в любой момент — тогда после паузы подписка не возобновится.',
  'billing.autoRenew.remove': 'Удалить карту',
  'billing.autoRenew.changeCard': 'Изменить карту',
  'billing.autoRenew.cancel': 'Отменить подписку',
  'billing.autoRenew.nextCharge': 'Следующее списание: {{date}} · {{amount}}',
  'billing.autoRenew.nextChargeDate': 'Следующее списание: {{date}}',
  'billing.autoRenew.canceledUntil': 'Подписка активна до {{date}}, продлеваться не будет.',
  'billing.autoRenew.canceled': 'Автопродление отключено.',
  // «Пауза на 1 месяц» in the cabinet (09.10). `running` — inside the window;
  // `scheduled` — pressed, the paid period still runs. Both dates server-side.
  'billing.pause.running': 'Пауза до {{until}}: доступ закрыт, списание {{until}}',
  'billing.pause.scheduled': 'С {{from}} пауза до {{until}}: доступ закроется, списание {{until}}',
  'billing.pause.resume': 'Возобновить сейчас',
  'billing.pause.resumeNote':
    'Спишем по обычному тарифу в течение пары часов, доступ откроется сразу.',
  'billing.pause.cancel': 'Отменить паузу',
  'billing.autoRenew.declined':
    'Не удалось списать оплату — обновите карту, чтобы продолжить автопродление.',
  'billing.autoRenew.updateCard': 'Обновить карту',
  // ── Причина отписки (2026-09-21) ──────────────────────────────────────────
  // Спрашиваем ДО действия, а не после: человек, который уже отписался, уже
  // ушёл со страницы. Это не стена удержания — крестик закрывает без
  // изменений, галочка остаётся включённой. Igor, 10.10: короче — заголовок
  // вопросом-действием, причины в два-три слова, пауза основной кнопкой.
  'churn.title.autoRenew': 'Отключить автопродление?',
  'churn.title.card': 'Удалить карту?',
  'churn.why': 'Почему?',
  'churn.value': 'По вашим поискам за месяц пришло {{n}} {{word}}',
  'churn.confirm.autoRenew': 'Отключить продление',
  'churn.confirm.card': 'Удалить карту',
  // The MAIN button since 10.10 (Igor). The charger takes the subscription's
  // locked-in price after a pause (`lockedPriceUzs ?? plan price`), so «по
  // старой цене» holds for every subscriber with a locked price.
  'churn.pause': 'Пауза на 1 месяц — потом продолжится по старой цене',
  // A REAL pause (Igor, 09.10): Pro closes at the end of the paid period, no
  // charge for a month, then the subscription carries on. `from` = the period
  // end, `to` = the end of the pause = the next charge. The dateless variant is
  // only a fallback for a session without a period end.
  'churn.pauseNote': 'Доступ закроется {{from}}, без списаний до {{to}}.',
  'churn.pauseNoteNoDate': 'Доступ закроется на месяц, без списаний.',
  'churn.pickReason': 'Выберите причину',
  'churn.detailsLabel': 'Подробнее (необязательно)',
  // Both the LABEL under «Другое» (where the box is mandatory) and the message
  // shown if it is submitted empty — deliberately the same sentence, so the
  // message points at the field by repeating its name.
  'churn.detailsRequired': 'Расскажите подробнее',
  // One line above the buttons, chosen by the reason (churn-reasons.ts). Each
  // names the concrete thing that would fix THAT reason; no discounts, no
  // arguing — the sheet must not become a retention wall.
  'churn.retain.noRelevantTenders': 'Напишите нам в Telegram — настроим поиск под вас за 10 минут',
  'churn.retain.poorAlerts': 'Сузим поиск — напишите в Telegram',
  // «Меняю карту» on the card sheet opens the attach sheet instead of deleting
  // (Igor, 10.10); the confirm button then reads «Изменить карту».
  'churn.retain.changingCard': 'Карту удалять не нужно — привяжите новую, старая заменится',
  'churn.reason.changingCard': 'Меняю карту',
  'churn.reason.noCardStorage': 'Не хочу хранить карту',
  'churn.reason.stopRenewing': 'Не буду продлевать',
  'churn.reason.noRelevantTenders': 'Нет подходящих тендеров',
  'churn.reason.didNotWin': 'Не выиграл',
  'churn.reason.noTime': 'Нет времени',
  'churn.reason.foundBetter': 'Нашёл другой сервис',
  'churn.reason.tooExpensive': 'Дорого',
  'churn.reason.oneOffNeed': 'Нужно было один раз',
  'churn.reason.poorAlerts': 'Мало полезных оповещений',
  'churn.reason.hardToUse': 'Сложно разобраться',
  'churn.reason.paymentIssue': 'Проблема с оплатой',
  'churn.reason.other': 'Другое',
  'billing.history.title': 'История платежей',
  'billing.history.showAll': 'Показать все ({{count}})',
  'billing.history.fiscalReceipt': 'Фискальный чек',
  'billing.history.status.completed': 'Оплачено',
  'billing.history.status.pending': 'Ожидает оплаты',
  'billing.history.status.preparing': 'Обрабатывается',
  'billing.history.status.cancelled': 'Отменён',
  'billing.autoRenew.addPrompt':
    'Привяжите карту, чтобы подписка продлевалась автоматически — без ручной оплаты каждый период.',
  'billing.autoRenew.addCard': 'Привязать карту',
  'billing.card.title': 'Привязка карты',
  'billing.card.titleSubscribe': 'Оформление подписки',
  'billing.card.subtitle': 'Данные карты обрабатываются на стороне Payme. Мы карту не храним.',
  // The charge schedule moved into the summary box below, which states it as
  // amounts rather than prose. Repeating it here made the reader parse the
  // same fact twice; what prose is still needed is the part the table cannot
  // say — that we never hold the card.
  'billing.card.subscribeSubtitle': 'Карту мы не храним — данные обрабатывает Payme.',
  'billing.card.securedBy': 'Платёж защищён',
  'billing.card.planLabel': 'Тариф',
  'billing.card.chargeNowLabel': 'Спишется сейчас',
  'billing.card.policyPrefix': 'Оформляя подписку, вы принимаете',
  'billing.card.policyOffer': 'оферту',
  // Was: «. При отказе от подписки стоимость уже начавшегося оплаченного периода
  // не возвращается.» — moved OUT of checkout and left to the оферта, which has
  // carried it verbatim since the Payme compliance pass (content/legal.ts §5).
  // The recurring disclosure stays on screen in `subscribeSubtitle`.
  // NOT «Далее» — the submit button says «Далее» meaning "next step", and the
  // two sat on the same screen meaning different things («Далее 79 000 {{currency}}
  // каждый месяц» above a button labelled «Далее»). Name the thing instead.
  'billing.card.renewLabel': 'Автопродление',
  'billing.card.thenMonthly': '{{amount}} каждый месяц',
  'billing.card.thenYearly': '{{amount}} каждый год',
  // ⚠️ «7 дней», not 3: REMIND_WINDOW_DAYS in scripts/renewal-reminders.ts is
  // pinned at >=7 to satisfy the Visa/Mastercard recurring rules (notify the
  // cardholder at least 7 days before a charge). The number is interpolated
  // from that constant, never typed here.
  // The cancel path names the REAL controls — /plans → «Ваша подписка» → the
  // «Автопродление» checkbox. There is no «Подписка» page to send anyone to.
  'billing.card.upsellYear': 'Перейти на год — {{months}} месяцев бесплатно',
  'billing.card.pitchCategory':
    '{{count}} тендеров вашей категории закрываются на этой неделе — контакты внутри',
  'billing.card.pitchMarket': 'Сейчас открыто {{count}} тендеров на {{sum}} {{currency}}',
  'billing.card.payAmount': 'Оплатить {{amount}}',
  'billing.card.nextChargeOn': 'Следующее списание — {{date}}.',
  // No «за 7 дней» since 2026-10-11 (owner): the sentence now sits right under
  // «7 дней — гарантия возврата средств», and two different sevens in two lines
  // read as one confusing promise. The reminder itself still goes out
  // RENEWAL_REMINDER_DAYS before the charge.
  'billing.card.remindTelegram': 'Напомним в Telegram.',
  'billing.card.remindEmail': 'Напомним по почте.',
  'billing.card.cancelHow': 'Отключение в два клика в «Тарифах».',
  'billing.card.cancelAnytime': 'Отменить автопродление можно в любой момент в личном кабинете.',
  // Period qualifier on the tariff NAME in the subscribe header («Pro на месяц»).
  'billing.card.periodMonthly': 'на месяц',
  'billing.card.periodAnnual': 'на год',
  // Confirm-step recap: what is being paid + from which card.
  'billing.card.otpRecap': 'Оплата {{amount}} с карты {{card}}',
  // Where the fiscal receipt lands, per gateway (Payme app / OCTO ОФД in history).
  'billing.card.receiptPayme': 'Фискальный чек придёт в приложение Payme',
  'billing.card.receiptOcto': 'Фискальный чек будет доступен в истории платежей',
  // Dated renewal timeline shown in the subscribe modal.
  'billing.card.timelineToday': 'Сегодня',
  'billing.card.timelineTodayText': '{{amount}}, доступ открывается сразу',
  'billing.card.timelineRemind': 'письмо-напоминание о продлении',
  // The reminder step names the REAL channel: Telegram only for a linked
  // account (renewal-reminders.ts → «Telegram when deliverable, else email»),
  // otherwise email. Promising Telegram to someone who never linked it is a
  // promise broken by the very message meant to keep it.
  'billing.card.timelineRemindTelegram': 'напомним в Telegram',
  'billing.card.timelineRemindEmail': 'напомним по почте',
  'billing.card.timelineRenew': 'продление',
  'billing.card.timelineToggle': 'Оплата и продление',
  'billing.card.renewLine': 'Продление {{date}}.',
  'billing.card.nextHint': 'Дальше придёт SMS с кодом от Payme.',
  // The lock line under the card fields (2026-10-11, owner): where the SMS code
  // comes from, and that the card number goes to Payme, not to us — true, the
  // browser sends it straight to checkout.paycom.uz (payme-subscribe-client).
  // Short on purpose: it has to stay ONE line with its lock at 360px.
  'billing.card.smsFromPayme': 'SMS-код от Payme, номер карты мы не видим',
  // Value pill under the price — what the buyer's own niche is worth right now,
  // keyed by how much we know about them (a saved-search subject, a direction,
  // or nothing → the whole live catalogue's daily pace).
  // {{lots}} + {{appears}} are pluralised in code (nicheHintLine) — «2 новых
  // лота» vs «5 новых лотов», «появляется» vs «появляются». Interpolating a bare
  // noun would print «4 новых лотов», the 5+ form, for a count of four.
  // «По вашим поискам», not «в вашей нише» — the count unions ALL of the buyer's
  // saved searches (categories, ИКПУ, niches), so a single-niche phrasing would
  // misdescribe a multi-subject subscriber. `daily` (no saved searches) stays
  // catalogue-wide.
  'billing.card.nicheOpen': 'По вашим поискам сейчас {{count}} {{lots}}',
  'billing.card.nicheDirection': 'По вашим поискам {{appears}} {{count}} {{lots}} в месяц',
  'billing.card.nicheDaily': 'Каждый день {{appears}} {{count}} {{lots}}',
  // Trust block under the pay button. `securedBy` alone is «Платёж защищён»;
  // these name the processor, so the reassurance is specific and honest per
  // gateway (Payme inline vs Octobank redirect).
  'billing.card.securedByPay': 'Платёж защищён — обрабатывает Payme',
  'billing.card.securedByOcto': 'Платёж защищён — обрабатывает Octobank',
  // A window, not a deadline for the money. Оферта §5 gives the buyer 7 calendar
  // days from the FIRST payment to ASK for a refund and pays it out «в срок до 10
  // (десяти) рабочих дней» — «вернём деньги в течение 7 дней» read as the payout
  // promise and contradicted the document the buyer accepts on the same sheet.
  // Wording 2026-10-11 (owner): «гарантия возврата средств» is the phrase people
  // know; «7 дней» first because it is also the headline of the payment sheet
  // and the line under the plan-card buttons. Still a window to ASK, as above.
  'billing.card.refund7': '7 дней — гарантия возврата средств',
  'billing.card.securedByClick': 'Платёж защищён — обрабатывает Click',
  'billing.card.securedByPayClick': 'Платёж защищён — обрабатывает Payme или Click',
  'billing.card.supportTg': 'Поддержка в Telegram',
  // Short nominative labels for the trust-block link row (the mock's «Оферта ·
  // Конфиденциальность»), NOT the declined policyOffer/policyPrivacy («…принимаете
  // оферту и политику конфиденциальности») used in the consent sentence.
  'billing.card.offerLink': 'Оферта',
  'billing.card.privacyLink': 'Конфиденциальность',
  'billing.card.policyAnd': 'и',
  'billing.card.policyPrivacy': 'политику конфиденциальности',
  'billing.card.policySuffix': '.',
  'plans.subscribeWithCard': 'Подписаться на {{name}}',
  'plans.payOnceLead': 'Оплата на стороне Payme · карту вводить у нас не нужно',
  // Gateway-aware variant for the pay-once chooser, so the reassurance names the
  // gateway actually selected (Payme or Click) — both are hosted redirects.
  'plans.payOnceLeadVia': 'Оплата на стороне {{gateway}} · карту вводить у нас не нужно',
  // The second CTA on a monthly card (2026-09-06): opens the gateway chooser
  // sheet below. No «Автопродление · отмена в любой момент» line under the
  // subscribe button any more — the renewal disclosure lives in the card modal's
  // dated timeline, where the buyer actually decides.
  'plans.payOnceBtn': 'Оплатить разово',
  // Instagram / Telegram on Android: the card subscription as the ONLY button
  // (`cardOnlyCheckout`). Same product and price as «Подписаться»; the
  // renewal is said in words under it.
  'plans.cardOnlyCta': 'Оплатить картой',
  'plans.checkoutLinkFailed': 'Не удалось открыть страницу оплаты. Нажмите «Оплатить» ещё раз.',
  // Kazakhstan (Stripe, 2026-10-13): the line under «Подписаться» and the
  // refusal when a subscription is still set to renew. Uzbekistan never renders them.
  'plans.stripe.renews':
    'Подписка продлевается каждый месяц. Отключить продление можно в любой момент здесь же, на странице тарифов.',
  'plans.stripe.alreadySubscribed':
    'У вас уже есть подписка, которая продлевается. Чтобы сменить тариф, отключите автопродление ниже — оплаченный период сохранится — и оформите новый.',
  'plans.stripe.payee': 'Платежи картой принимает {{name}} (США) через Stripe',
  // Owner, 2026-10-20 (KZ): the pricing page names no payee company — «ООО FASTAGO» in
  // the footer is the one legal entity shown; a second one is friction, not trust.
  'plans.stripe.secureNote': 'Платёж картой защищён и проходит через Stripe',
  // Kazakhstan (Stripe, 2026-10-17): under «Подписаться» inside Instagram /
  // Facebook / Telegram's own browser, where 3-D Secure failed on 15.10. The
  // copy action reuses `plans.handoffCopy` / `plans.handoffCopied`.
  'plans.stripe.inAppHint': 'Оплата надёжнее в браузере: откройте эту страницу в Chrome или Safari',
  'plans.stripe.inAppOpen': 'Открыть в браузере',
  // Kazakhstan (Stripe Elements, 2026-10-19): the card form in OUR modal
  // (`StripeCardModal`). Uzbekistan never renders them.
  'billing.stripe.payMonthly': 'Оплатить {{amount}} / мес',
  'billing.stripe.payAnnual': 'Оплатить {{amount}} / год',
  'billing.stripe.loading': 'Готовим форму оплаты…',
  'billing.stripe.loadFailed':
    'Не удалось открыть форму оплаты. Закройте окно и попробуйте ещё раз.',
  'billing.stripe.errorFunds':
    'Недостаточно средств на карте. Пополните её или введите другую карту.',
  'billing.stripe.errorExpired': 'Срок действия карты истёк. Введите другую карту.',
  'billing.stripe.errorCard': 'Проверьте номер карты, срок действия и CVC.',
  'billing.stripe.error3ds':
    'Банк не подтвердил платёж. Попробуйте ещё раз или введите другую карту.',
  'billing.stripe.errorDeclined':
    'Банк отклонил платёж. Попробуйте другую карту или обратитесь в банк.',
  'billing.stripe.errorGeneric': 'Платёж не прошёл. Попробуйте ещё раз.',
  'plans.cardOnlyPrice': '{{amount}} / мес',
  'plans.cardOnlyRenews': 'Продлевается каждый месяц. Отключить можно в кабинете в любой момент.',
  'plans.onceSheetTitle': 'Тариф {{name}} — 1 месяц',
  'plans.onceSheetPick': 'Выберите приложение для оплаты',
  // The primary control under the gateway strip. It is an <a> once the order is
  // prepared, so the label has to name the ACTION and the amount — a buyer must
  // never follow a link without knowing what it charges.
  'plans.oncePayNow': 'Оплатить {{amount}}',
  // The one non-interactive state this sheet allows: the order is being created
  // so the button can become a real link. One round trip, never a validation
  // state, and it says what it is doing rather than looking broken.
  'plans.oncePreparing': 'Готовим оплату…',
  // Shown ONLY inside the Instagram browser on Android, where the payment page
  // is handed to Chrome instead of this WebView (it cannot finish 3-DS).
  'plans.onceExternalHint': 'Оплата откроется в браузере телефона',
  // The Instagram→Chrome hand-off was swallowed by the WebView: the buyer is
  // still on our sheet with a payment page that never opened. Short, no blame,
  // three ways out (copy / new tab / read it).
  'plans.handoffStuck': 'Не открылось? Откройте ссылку в браузере телефона',
  'plans.handoffCopy': 'Скопировать ссылку',
  'plans.handoffCopied': 'Скопировано',
  'plans.onceSheetClose': 'Закрыть',
  // «Payme или Click», not «приложение банка»: the hosted checkout is their web
  // page, which deep-links into the app only when it is installed.
  // Same footnote shape as under the subscribe button: WHEN access ends, then
  // the renewal term. «Без автопродления» alone read as an excuse (Igor,
  // 2026-09-07); the gateways are now named on the buttons themselves.

  // Dated access block, mirroring the subscribe card's timeline.
  'plans.onceTimelineTitle': 'Оплата и доступ',
  // {{word}} — день/дня/дней по числу (daysWord): месяц бывает 28–31 день, и
  // «Доступ на 31 дней» стоял на листе разовой оплаты в каждом 31-дневном месяце.
  'plans.onceAccessLine': 'Доступ на {{days}} {{word}}, до {{date}}. Без автопродления.',
  'plans.onceTimelineSub': 'Доступ на {{days}} {{word}}',
  'plans.onceTimelineToday': 'Сегодня',
  'plans.onceTimelineTodayText': '{{amount}}, доступ открывается сразу',
  'plans.onceTimelineEnd': 'доступ закончится',
  // Social proof under the page lead. Since 2026-10-13 the page shows the LIVE
  // count (`plans.socialLive` below, from the public landing stats); THIS line
  // is what it shows until the number arrives and whenever it is unavailable —
  // in the prerendered HTML, on a failed request. So the figure here is a
  // FLOOR, not the claim: UNIQUE TINs of non-internal accounts on 2026-10-14
  // were 2 041 (SELECT count(DISTINCT tin) FROM users WHERE NOT internal AND
  // tin IS NOT NULL) — the owner's rule since 14.10: count companies that named
  // their ИНН, not every registration (6 826 that day). It only has to stay
  // true, and it does for as long as accounts are not deleted in bulk; raise it
  // when the live number has clearly left it behind, so the first paint and
  // the live line do not visibly disagree. Never a number the table does not
  // back.
  'plans.social': 'С нами уже более 2 000 поставщиков Республики {{country}}',
  // The same sentence with the live number: {{count}} is the unique-TIN
  // count rounded DOWN to a hundred and already formatted («2 000»). Shown only
  // from 500 accounts up (`socialProofCount`) — a small deployment keeps the
  // static line above, which on Kazakhstan carries no number at all.
  'plans.socialLive': 'С нами уже более {{count}} поставщиков Республики {{country}}',
  // Live-count pill on the card for GUESTS (signed-in buyers get their own
  // saved-search count via `billing.card.niche*`). {{word}} is the pluralised
  // noun, filled in code via `pluralRu`.
  'plans.openNow': 'Сейчас {{count}} {{word}}',
  // Feature groups on the Pro card (2026-09-06). Business lists only what it
  // ADDS on top of Pro, under `plans.business.plus`.
  'plans.group.search': 'Поиск',
  'plans.group.contacts': 'Связь',
  'plans.group.analysis': 'Анализ',
  'plans.business.plus': 'Всё из Pro, плюс:',
  'plans.octo.title': 'Оформление подписки',
  'plans.octo.tabOcto': 'Octobank',
  'plans.octo.tabPayme': 'Payme',
  'plans.octo.continue': 'Продолжить на Octobank',
  'plans.octo.redirectNote': 'Данные карты вводятся на защищённой странице Octobank',
  'plans.octo.error': 'Не удалось начать оплату. Попробуйте ещё раз.',
  'plans.accessUntil':
    'Доступ к анализу данных активен после оплаты, до {{date}} · отменить можно в любое время',
  'plans.cantPay': 'Не получается оплатить?',
  // Checkout reassurance strip on /plans — answers the objections a buyer has
  // before clicking pay (card safety, surprise charges, legitimacy).
  'plans.trust.secureTitle': 'Безопасная оплата',
  'plans.trust.secureText':
    'Карту обрабатывают Payme, Click и Octobank — мы не видим и не храним её номер',
  'plans.trust.noSurpriseTitle': 'Без скрытых списаний',
  'plans.trust.noSurpriseText':
    'Можно заплатить один раз. Автопродление — по желанию, с напоминанием и отменой в любой момент',
  // Worded to the offer (content/legal.ts §, «в порядке исключения»): the
  // goodwill refund covers the FIRST payment, on request to support within 7
  // calendar days — not renewals. The page must not promise more than the
  // document the buyer accepts.
  'plans.trust.refundTitle': 'Гарантия возврата',
  'plans.trust.refundText':
    'Первая оплата не подошла? Напишите нам в течение 7 дней — вернём деньги',
  'plans.trust.receiptTitle': 'Официальный чек',
  'plans.trust.receiptText': 'После оплаты приходит официальный фискальный чек',
  'billing.card.smsFrom':
    'SMS с кодом придёт от Payme (не от {{brand}}) на номер, привязанный к карте.',
  // ⏱ MM:SS, formatted in code and passed as {{time}} (was «{{seconds}} сек.»).
  // Always on the OTP step — a buyer with two SMS in his inbox cannot tell
  // which code this sheet is verifying against (traced 2026-09-23).
  'billing.card.otpUseLast': 'Введите код из последнего SMS',
  'billing.card.resendIn': 'Отправить код ещё раз можно через {{time}}',
  'billing.card.resend': 'Отправить код ещё раз',
  'billing.card.errorResend': 'Не удалось отправить код. Попробуйте ещё раз.',
  'billing.card.otpSubtitle': 'Введите код из SMS от Payme.',
  // ── OTP confirmation step ────────────────────────────────────────────────
  'billing.card.otpTitle': 'Подтвердите оплату',
  'billing.card.otpBack': 'Назад',
  // Accessible label for the 2nd–6th code boxes (the 1st carries «Код из SMS»),
  // so each box is uniquely named for screen readers.
  'billing.card.otpDigit': 'Цифра {{n}}',
  // 3-step progress stepper (Карта → Код → Доступ).
  'billing.card.stepCard': 'Карта',
  'billing.card.stepCode': 'Код из SMS',
  'billing.card.stepAccess': 'Доступ открыт',
  // Which phone the SMS went to. `smsSentTo` when Payme returns a masked number,
  // else the generic fallback (we never receive the raw number ourselves).
  'billing.card.smsSentTo': 'Payme отправил SMS с кодом на {{phone}}.',
  'billing.card.smsSentGeneric': 'Payme отправил SMS с кодом на номер, привязанный к карте.',
  // Charge recap on the confirm step: scheme + masked card + amount.
  'billing.card.otpChargeLine': '{{scheme}} {{card}} · спишется {{amount}}',
  'billing.card.confirmPay': 'Подтвердить оплату',
  'billing.card.otpFraud': 'Никому не называйте код — сотрудники {{brand}} его не спрашивают.',
  'billing.card.number': 'Номер карты',
  // «Срок», not «Срок действия» — the field is now a narrow column beside the
  // number in a two-column row, and the shorter label fits it without wrapping.
  'billing.card.expire': 'Срок',
  // The hint inside the field. It was hard-coded in Cyrillic in the component,
  // so the Uzbek sheet showed «ММ/ГГ» too.
  'billing.card.expirePlaceholder': 'ММ/ГГ',
  'billing.card.otp': 'Код из SMS',
  'billing.card.next': 'Далее',
  'billing.card.confirm': 'Подтвердить',
  'billing.card.errorCard': 'Не удалось привязать карту. Проверьте номер и срок действия.',
  'billing.card.errorCardNotAccepted':
    'Проверьте номер карты и срок. Если всё верно — попробуйте ещё раз через минуту или другую карту.',
  'billing.card.errorTinRequired':
    'Для этого тарифа нужен ИНН компании. Укажите его в настройках и повторите оплату — код из SMS здесь ни при чём.',
  'billing.card.errorOtp': 'Неверный код. Попробуйте ещё раз.',
  'billing.card.errorChargeFailed': 'Банк отклонил списание с этой карты. Попробуйте другую карту.',
  'billing.card.errorInsufficientFunds':
    'На карте недостаточно средств. Пополните её или используйте другую.',
  'billing.card.errorCardNotFound': 'Карта с таким номером не найдена. Проверьте номер.',
  'billing.card.errorCorporateCard':
    'Это корпоративная карта — Payme её не принимает. Используйте другую карту или оплатите через Octobank.',
  'billing.card.errorCardBlocked': 'Карта заблокирована банком. Используйте другую карту.',
  'billing.card.errorCardExpired': 'Срок действия карты истёк. Используйте другую карту.',
  'billing.card.errorSmsNotEnabled':
    'У карты не включено SMS-информирование. Включите его в банке или используйте другую карту.',
  'billing.card.errorWrongExpiry': 'Неверный срок действия. Проверьте месяц и год.',
  'billing.card.errorWrongNumber': 'Неверный номер карты. Проверьте номер.',
  'billing.card.errorCardNotServed': 'Эта карта не подходит для онлайн-оплаты. Используйте другую.',
  'billing.card.errorLimitExceeded': 'Исчерпан месячный лимит карты. Используйте другую карту.',
  'billing.card.errorCurrency': 'Валюта карты не подходит. Нужна карта в сумах.',
  'billing.card.errorProcessingUnavailable':
    'Банк временно недоступен. Попробуйте через несколько минут.',
  'billing.card.errorOtpExpired': 'Код истёк. Запросите новый.',
  'billing.card.errorOtpAttempts': 'Попытки ввода исчерпаны. Запросите новый код.',
  'billing.card.errorEmpty': 'Введите номер карты',
  'billing.card.errorExpireEmpty': 'Укажите срок',
  'billing.card.errorIncomplete': 'Введите 16 цифр номера карты',
  'billing.card.errorInvalidNumber': 'Номер карты введён неверно',
  'billing.card.errorUnsupported':
    'Такая карта не поддерживается. Проверьте номер: принимаются Uzcard, Humo, Visa и Mastercard.',
  'billing.card.errorPaymeBrandUnsupported':
    'Эта карта не подходит для автоплатежа. Оплатите разово — кнопка «Оплатить разово» на тарифе.',
  'billing.card.errorUnsupportedOcto':
    'Эта карта не поддерживается через Payme. Оплатите через Octobank — он принимает Visa и Mastercard.',
  'billing.card.payViaOcto': 'Оплатить через Octobank',
  'billing.card.foreignBrandHint': 'Payme принимает только Uzcard и Humo.',
  'billing.card.corporateOcto': 'Payme не принимает корпоративные карты.',
  'billing.card.errorExpired': 'Срок действия истёк',
  'billing.card.errorExpireInvalid': 'Неверный срок',
  'plans.perYear': '/ год',
  'plans.periodMonth': 'месяц',
  'plans.periodYear': 'год',
  'plans.perMonth': '/ мес',
  'plans.from': 'от',
  'plans.tiersCount': '{{count}} {{word}} на выбор',
  // Catalogue banner sub-line (2026-09-06): the year pitch, derived from live
  // prices; the pair line is the fallback when the prices do not back a ×2.
  'plans.bannerYear': 'Год — за цену 6 месяцев',
  'plans.bannerPair': 'Pro и Бизнес · месяц или год',
  // Plan names, per locale. The DB holds one Russian label per plan and the
  // Uzbek page rendered it verbatim; keyed by plan-key FAMILY so pro-monthly
  // and pro-yearly share one entry. «YaTT» = yakka tartibdagi tadbirkor, the
  // Uzbek for ИП.
  'plans.name.pro': 'Pro',
  'plans.name.business': 'Бизнес',
  'plans.name.ip': 'ИП',
  'plans.name.free': 'Старт',
  'plans.som': '{{currency}}',
  'plans.feature.opens': '{{count}} открытий контактов в месяц',
  'plans.feature.categoryLimit': 'До {{count}} категорий',
  'plans.feature.categoryLimitUnlimited': 'Неограниченно категорий ЕНКТ',
  'plans.feature.categoryNiche': '1 ниша ЕНКТ + Telegram-алерты',
  'plans.feature.contactsNiche': 'Каталог госзакупок',
  'plans.feature.allTenders': 'Все тендеры Республики {{country}} (35+ источников)',
  // Corporate sources we actually harvest (tender_sources scope=corporate:
  // beeline, ucell, kapitalbank, aloqabank, trustbank, sqb, ofb, …; Uzum's
  // procurement arrives through the b2biz aggregator — 9 lots, measured
  // 2026-09-06). Do NOT name a company the catalogue does not hold — this line
  // is a claim on the pricing page.
  'plans.feature.privateTenders': 'Частные тендеры: банки, телеком и крупные компании',
  'plans.feature.ifi': 'Тендеры МФИ: Всемирный банк, ADB, ООН',
  'plans.feature.contactsMetered': '{{count}} {{word}} заказчиков в месяц',
  'plans.feature.budgetCeiling': 'Тендеры с бюджетом до {{amount}} млн {{currency}}',
  'plans.feature.contactsAll': 'Все контакты заказчиков — без лимита',
  'plans.feature.winnerContacts': 'Контакты победителей прошлых тендеров — телефон и почта',
  // «спецификации», not «договор»: of ~5k live document names only ~30 are a
  // contract draft, ~160 are ТЗ/спецификации (measured 2026-09-06).
  'plans.feature.documents': 'Документы тендера (ТЗ, спецификации)',
  'plans.feature.procedure': 'Порядок проведения процедуры',
  'plans.feature.aiSummary': 'Разбор и требования ТЗ — бесплатно',
  'plans.feature.aiSummaryFull': 'Полный разбор и требования ТЗ (UZ/RU)',
  'plans.feature.savedSearchOne': 'До 3 сохранённых поисков + Telegram-алерты',
  'plans.feature.savedSearchAll': 'Безлимит сохранённых поисков + алерты',
  'plans.feature.supplierProfile': 'Профиль по вашим выигранным тендерам — алерты без настройки',
  'plans.feature.telegramBot': 'Telegram-бот: поиск, ИИ-ответы, дайджесты, управление подписками',
  'plans.feature.export': 'Экспорт в Excel',
  'plans.feature.buyerAnalytics':
    'Анализ заказчиков: с кем работают, концентрация закупок и годовой объём',
  // What `analyticsEnabled` actually gates is the PER-TENDER detail (winner
  // prices, base rates, supplier intel); the market dashboard and the ИКПУ
  // price reference are public, so they cannot be sold as a Pro feature.
  'plans.feature.analytics': 'Цены победителей и базовые ставки по каждому тендеру',
  'plans.feature.orgWatch':
    'Слежение за 50 заказчиками и конкурентами — уведомления о новых контрактах',
  'plans.feature.prioritySupport': 'Приоритетная поддержка',
  // The seat count comes from the plan row — never hard-code it here, or the
  // pricing page will keep promising 3 seats after the DB says 5. Worded so any
  // number stays grammatical (genitive plural «мест» after the noun-first form).
  'plans.business.seats': 'Мест в команде: {{count}} — вы и ваши сотрудники',
  'plans.business.seatsGeneric': 'Несколько мест для команды',
  'plans.business.telegram': 'У каждого сотрудника свой Telegram-бот и свои оповещения',
  'baseRates.title': 'Рыночные данные',
  'baseRates.hint':
    'Медиана скидки от стартовой цены, число участников и диапазон цены победителя по завершённым закупкам той же категории и близкого размера (от 0,3 до 3 бюджетов этого лота). Помогает оценить конкуренцию и справедливую цену.',
  'baseRates.competition': 'Медиана участников',
  'baseRates.discount': 'Медианная скидка',
  // Скидка — главная цифра панели: она сопоставима между лотами любого размера,
  // а абсолютная цена — нет. Подпись объясняет, во что её превращает поставщик.
  'baseRates.discountCaption': 'Насколько победители опускались от стартовой цены',
  'baseRates.degenerate':
    '{{pct}}% закупок с тем же значением — это правило площадки, а не рыночный показатель',
  'baseRates.priceBand': 'Диапазон цены победителя',
  'baseRates.priceMedian': 'Медиана цены победителя',
  'baseRates.priceBasisBanded': 'Медиана по сравнимым закупкам такого же размера',
  'baseRates.priceBasisSection': 'Медиана по всей категории — без учёта размера лота',
  'baseRates.basisBanded':
    'По {{n}} сравнимым закупкам: цена победителя {{min}} – {{max}}, {{from}} – {{to}}',
  'baseRates.basisBandedNoDates': 'По {{n}} сравнимым закупкам: цена победителя {{min}} – {{max}}',
  'baseRates.basisSection': 'По {{n}} закупкам категории, {{from}} – {{to}}',
  'baseRates.basisSectionNoDates': 'По {{n}} закупкам категории',
  // Locked teaser: the ONE true line under the blurred card — how many
  // comparables it is built from and over what period. Never a value.
  // Период — ДЛИНА окна, а не пара ISO-дат: сырых дат пользователь на сайте
  // не видит нигде.
  'baseRates.teaserBasis': 'По {{n}} сравнимым закупкам за {{period}}',
  'baseRates.teaserBasisNoDates': 'По {{n}} сравнимым закупкам',
  'baseRates.teaserMonths.one': '{{n}} месяц',
  'baseRates.teaserMonths.few': '{{n}} месяца',
  'baseRates.teaserMonths.many': '{{n}} месяцев',
  'baseRates.sizeBlind':
    'У лота не указан бюджет, поэтому сравнение идёт по всей категории и не учитывает размер лота.',
  'baseRates.positionBelow': 'Бюджет лота ниже типичной цены победителя по таким закупкам',
  'baseRates.positionInside': 'Бюджет лота внутри типичного диапазона цен победителей',
  'baseRates.positionAbove': 'Бюджет лота выше типичной цены победителя по таким закупкам',
  'baseRates.insufficient': 'Пока недостаточно данных по этой категории',
  'baseRates.locked': 'Аналитика доступна в тарифе Pro',
  'baseRates.lockedCta': 'Посмотреть тарифы',
  // ── Price reference (#46) ──────────────────────────────────────
  // ── Market dashboard ───────────────────────────────────────────
  'market.title': 'Рынок госзакупок {{countryGen}}',
  'market.subtitle':
    'Открытые тендеры и итоги закупок в цифрах: бюджеты, регионы, сектора и динамика.',
  'market.summary':
    'Сейчас открыто {{active}} государственных тендеров {{countryGen}} на сумму {{budget}}; за последнюю неделю добавилось {{newWeek}}. Ниже — распределение бюджета по регионам и секторам и итоги завершённых закупок.',
  'market.seo.title': 'Рынок госзакупок {{countryGen}} — статистика и аналитика',
  'market.seo.description':
    'Аналитика рынка госзакупок {{countryGen}}: сколько тендеров открыто, бюджеты по регионам и секторам, объём и конкуренция по итогам закупок.',
  'market.som': '{{currency}}',
  'market.count': '{{count}} закупок',
  'market.generatedAt': 'Данные на {{date}}',
  'market.kpi.active': 'Активных тендеров',
  'market.kpi.budget': 'Бюджет на рынке',
  'market.kpi.newWeek': 'Новых за неделю',
  'market.kpi.closingSoon': 'Скоро закрытие',
  'market.kpi.awardedCount': 'Закупок за год',
  'market.kpi.awardedVolume': 'Объём за год',
  'market.byRegion': 'Бюджет по регионам',
  'market.byCategory': 'Бюджет по категориям',
  'market.newPerWeek': 'Новые тендеры по неделям',
  'market.awardedByYear': 'Закупок по годам',
  'chart.noData': 'нет данных',
  'market.competition': 'Медиана участников по секторам',
  'market.discount': 'Медианная скидка по секторам',
  'market.range.from': 'Дата с',
  'market.range.to': 'Дата по',
  'market.range.reset': 'Сбросить период',
  'nav.market': 'Рынок',
  'prices.title': 'Цены на товары',
  'prices.subtitle': 'Сколько в среднем платит государство за категорию товара',
  // Per-product SEO copy. Until 2026-08-12 all 386 `/prices/:ikpu` pages shipped
  // `prices.subtitle` verbatim as their meta description — the hub's own string — so
  // Google saw 386 near-identical thin pages (150-166 words, 67.7% shared vocabulary).
  // These build the description from the page's OWN numbers, which is also exactly the
  // kind of sourced statistic AI answer engines cite.
  // ⚠️ Says «цена контракта», never «цена за единицу» — the figure is a contract total
  // for the category, not a unit price (same caveat as `prices.caveat`). Do not reword
  // this into a unit-price claim.
  // ⚠️ The product code is deliberately NOT in these strings. It was, at the end,
  // and on a real product it pushed the line past the 155-char description cap —
  // so the tag shipped «…за 2023–2026, код…», a dangling label with the value cut
  // off, which reads as broken markup rather than a truncated sentence. The code is
  // already in the URL and the page body; the price figures are what earns the click
  // and what an AI answer engine quotes. Do not re-add it to the tail.
  'prices.seoTitle': '{{name}} — цены госзакупок',
  'prices.seoDesc.bandDated':
    'Медианная цена контракта «{{name}}» — {{median}} {{currency}}, диапазон {{p25}}–{{p75}}. По {{n}} завершённым госзакупкам {{countryGen}} за {{from}}–{{to}}.',
  'prices.seoDesc.band':
    'Медианная цена контракта «{{name}}» — {{median}} {{currency}}, диапазон {{p25}}–{{p75}}. По {{n}} завершённым госзакупкам {{countryGen}}.',
  'prices.seoDesc.sample':
    'Статистика завершённых госзакупок «{{name}}» в {{countryPrep}}: выборка {{n}} закупок с ценами победителей.',
  'prices.seoDesc.empty':
    'Сколько государство платит за «{{name}}» — данные по завершённым госзакупкам {{countryGen}}.',
  'prices.search': 'Поиск товара или кода',
  'prices.count': '{{count}} закупок',
  'prices.empty': 'Пока нет категорий с достаточной историей закупок.',
  'prices.back': '← К товарам',
  'prices.locked': 'Аналитика цен доступна на тарифе Pro.',
  'prices.locked.cta': 'Открыть Pro',
  'prices.insufficient': 'По этой категории пока мало завершённых закупок для статистики.',
  'prices.parentFallback':
    'По коду {{code}} завершённых закупок пока нет — показаны цены по более широкой категории «{{name}}».',
  'prices.band': 'Цена победителя',
  'prices.band.p25': '25% — ниже',
  'prices.band.median': 'медиана',
  'prices.band.p75': '75% — выше',
  'prices.discount': 'Медианная скидка от начальной цены',
  // The fraction of the headline sample that carries the field — say so, or
  // «по 141 закупкам» under «Выборка: 6104» reads as a contradiction.
  'prices.basedOn': 'по {{n}} закупкам из выборки, где источник публикует стартовую цену',
  'prices.discountUnknown':
    'нет данных: источник записывает стартовую цену как итоговую ({{n}} закупок)',
  'prices.noSourceData': 'источник не публикует эти данные',
  'prices.sampleNoDates': 'Выборка: {{n}} закупок · источник не публикует даты',
  'prices.sortBy': 'Сортировка:',
  'prices.sortCount': 'По объёму данных',
  'prices.sortName': 'По названию',
  'prices.participants': 'Медиана участников',
  'prices.sample': 'Выборка: {{n}} закупок · {{from}}–{{to}}',
  'prices.caveat': 'Показана стоимость контракта по категории, а не цена за единицу товара.',
  'nav.prices': 'Цены',
  'nav.results': 'Результаты',
  'baseRates.pricesLink': 'Полная история цен по категории →',
  'similarWinners.title': 'Кто выигрывает такие лоты',
  'similarWinners.hint':
    'Компании, выигравшие закупки с тем же кодом ЕНКТ за последние 24 месяца. Если по точному коду победителей меньше трёх — по классу кода (первые 6 цифр). Доля — доля побед.',
  'similarWinners.teaserBasis': '{{awards}} · {{winners}} за 24 месяца',
  'similarWinners.teaserCompanyN': 'Компания № {{n}}',
  'similarWinners.share': 'Доля побед',
  'similarWinners.basisExact': 'Код ЕНКТ {{code}}: {{awards}}, {{winners}} за 24 месяца',
  'similarWinners.basisClass':
    'Класс ЕНКТ {{code}} — по точному коду победителей мало: {{awards}}, {{winners}} за 24 месяца',
  'similarWinners.wins.one': '{{n}} победа',
  'similarWinners.wins.few': '{{n}} победы',
  'similarWinners.wins.many': '{{n}} побед',
  'similarWinners.companies.one': '{{n}} компания',
  'similarWinners.companies.few': '{{n}} компании',
  'similarWinners.companies.many': '{{n}} компаний',
  'supplierGraph.title': 'Концентрация поставщиков заказчика',
  'supplierGraph.hint':
    'Насколько закупки этого заказчика сосредоточены у немногих поставщиков и легко ли зайти новому участнику. Чем меньше контрактов, тем осторожнее вывод: до 10 он предварительный, до 5 его нет — только цифры. Прямые договоры без конкурса не учитываются.',
  'supplierGraph.teaserSuppliers': 'Победители и их доли',
  'supplierGraph.teaserConcentration': 'Концентрация',
  // Ранжированные строки запертой карточки: имена поставщиков в тизер не
  // попадают — только порядковый номер.
  'supplierGraph.teaserSupplierN': 'Поставщик № {{n}}',
  // Числительные склоняются в коде (pluralRuIndex + формы ниже), иначе выходит
  // «583 контрактов · 34 поставщиков».
  'supplierGraph.teaserBasis': '{{contracts}} · {{suppliers}} в истории заказчика',
  'supplierProfile.title': 'Профиль поставщика',
  'supplierProfile.back': '← Назад',
  'supplierProfile.locked': 'Профили поставщиков доступны на тарифе Pro.',
  'supplierProfile.lockedCta': 'Оформить Pro',
  'supplierProfile.empty': 'По этому поставщику пока нет данных.',
  'supplierProfile.contracts': 'Контрактов',
  'supplierProfile.totalValue': 'Сумма контрактов',
  'supplierProfile.avgValue': 'Средний контракт',
  'supplierProfile.buyers': 'Заказчиков',
  'supplierProfile.tenure': 'На рынке',
  'supplierProfile.tenureUnknown': 'источник не публикует даты закупок',
  // «Госзакупки за 12 месяцев» — the block only we can show (award graph).
  // Every figure states its own coverage; a number without it would be a lie
  // (bid detail covers ~16% of awards, starting prices only some sources).
  'supplierProfile.p12.title': 'Госзакупки за 12 месяцев',
  'supplierProfile.p12.wins': 'Выиграно контрактов',
  'supplierProfile.p12.value': 'Сумма контрактов',
  'supplierProfile.p12.discount': 'Медианная скидка от стартовой цены',
  'supplierProfile.p12.discountNote': 'по {{n}} контрактам со стартовой ценой',
  'supplierProfile.p12.participants': 'Медиана участников в выигранных лотах',
  'supplierProfile.p12.bids': 'Участие с детализацией',
  'supplierProfile.p12.bidsNote':
    '{{wins}} побед из {{n}} лотов, где источник публикует всех участников; полная доля участий неизвестна',
  'supplierProfile.p12.source':
    'По итогам госзакупок в базе {{brand}}, дата определения победителя за последние 12 месяцев.',
  'supplierProfile.topBuyers': 'Основные заказчики',
  'supplierProfile.categories': 'Категории',
  // Public list of the supplier's newest contracts — no buyer names (Pro).
  'supplierProfile.recentContracts': 'Недавние контракты',
  'supplierProfile.allContracts': 'Контракты',
  'supplierProfile.contractsMore': 'Показать ещё',
  'supplierProfile.regions': 'Регионы',
  'supplierProfile.debarred': 'В реестре недобросовестных поставщиков',
  'supplierProfile.nContracts': '{{n}} контр.',
  'buyer.title': 'Профиль заказчика',
  'buyer.back': '← Назад',
  // The public profile above is real; what Pro adds is the counterparty graph.
  // «Профили заказчиков доступны на Pro» under a fully rendered profile read
  // as an unfinished paywall (friend's audit, 2026-09-07).
  'buyer.locked': 'Поставщики этого заказчика, доли и повторные победители — на тарифе Pro.',
  'buyer.lockedCta': 'Оформить Pro',
  'buyer.tin': 'ИНН',
  // The company id printed before a number — «ИНН 306377222» on supplier and
  // buyer pages, a lot's winner, the cabinet's company card and watch list.
  // Kazakhstan prints «БИН» (ru.kz.ts) / «БСН» (kk.ts).
  'org.tinNumber': 'ИНН {{number}}',
  // ⚠️ The ИНН is IN the title on purpose. GSC (28 days to 2026-09-17) shows the
  // queries these pages win are company names AND bare ИНН — 2,719 supplier URLs
  // / 330 clicks, 3,085 buyer URLs / 255 clicks, average position 7-8. A title
  // that omits the number cannot match the query that brought the visitor.
  // Titles are capped at 68 and descriptions at 155 by <Seo>, so keep the intent
  // words SHORT: truncation cuts the tail, not the name.
  'buyer.seoTitle': '«{{name}}» — ИНН {{tin}}: закупки и поставщики',
  'buyer.seoDescription':
    '{{name}}, ИНН {{tin}} — {{awards}} контрактов на {{value}}, {{suppliers}} поставщиков, {{active}} активных тендеров. Категории и суммы — {{brand}}.',
  'supplier.seoTitle': '«{{name}}» — ИНН {{tin}}: госзакупки, контракты, победы',
  'supplier.seoDescription':
    '{{name}}, ИНН {{tin}} — {{contracts}} госконтрактов на {{value}}, {{buyers}} заказчиков, {{period}}. Категории и регионы поставок — {{brand}}.',
  'buyer.empty': 'По этому заказчику пока нет данных.',
  'buyer.dependenceFlag': 'Зависимость от одного поставщика — {{pct}}% расходов',
  'buyer.kpi.awards': 'Контрактов',
  'buyer.kpi.value': 'Сумма контрактов',
  'buyer.kpi.suppliers': 'Поставщиков',
  'buyer.kpi.active': 'Активных тендеров',
  // «Закупки за 12 месяцев» — our award graph; each figure names its coverage.
  'buyer.p12.title': 'Закупки за 12 месяцев',
  'buyer.p12.awards': 'Определено победителей',
  'buyer.p12.value': 'Сумма контрактов',
  'buyer.p12.discount': 'Медианная скидка от стартовой цены',
  'buyer.p12.discountNote': 'по {{n}} лотам со стартовой ценой',
  'buyer.p12.participants': 'Медиана участников',
  'buyer.p12.participantsNote': 'по {{n}} лотам с числом участников',
  'buyer.p12.singleBidder': 'Лотов с одним участником',
  'buyer.p12.source':
    'По итогам госзакупок в базе {{brand}}, дата определения победителя за последние 12 месяцев.',
  // Settlement delta — how far contracts land against the winning offer.
  // Two labels, because the value is signed: a contract ABOVE the offer is a
  // real outcome and must never be called a discount.
  'buyer.settlement.below': 'Контракт ниже предложения',
  'buyer.settlement.above': 'Контракт выше предложения',
  'buyer.settlement.sub': 'по {{n}} контрактам · {{pct}}% ниже',
  'buyer.settlement.source': 'Источник: xarid.imv.uz',
  'buyer.favoritism': 'Концентрация и фаворитизм',
  'buyer.topShareSplit': 'Топ-поставщик: {{value}}% суммы · {{count}}% контрактов',
  'buyer.streak': '{{name}} побеждал {{n}} раз подряд',
  'buyer.winnerSub': '{{wins}} побед · {{value}}% суммы / {{count}}% контрактов',
  'buyer.awardsByYear': 'Закупки по годам',
  'buyer.categories': 'Категории',
  'buyer.recentAwards': 'Недавние контракты',
  // Public (non-Pro) list of the buyer's recent tenders — no winner names.
  'buyer.recentTenders': 'Недавние тендеры',
  'buyer.viewProfile': 'Профиль заказчика',
  'supplierGraph.topShare': 'Доля топ-поставщика',
  'supplierGraph.topShareBasis': '{{wins}} из {{total}} контрактов',
  'supplierGraph.locked': 'Аналитика доступна в тарифе Pro',
  'supplierGraph.lockedCta': 'Посмотреть тарифы',
  'supplierGraph.insufficient': 'Пока недостаточно данных по этому заказчику',
  'supplierGraph.concentration.high': 'Закупки держат 1–2 поставщика',
  'supplierGraph.concentration.moderate': 'Есть постоянные поставщики',
  'supplierGraph.concentration.low': 'Поставщики меняются',
  'supplierGraph.concentrationHint.high': 'Новому участнику зайти сложно',
  'supplierGraph.concentrationHint.moderate': 'Зайти можно, но есть конкуренты-завсегдатаи',
  'supplierGraph.concentrationHint.low': 'Новому участнику зайти легко',
  'supplierGraph.tooEarly': '{{contracts}} — о концентрации судить рано',
  'supplierGraph.concentrationHedged.high': 'Закупки держат 1–2 поставщика · {{contracts}}',
  'supplierGraph.concentrationHedged.moderate': 'Есть постоянные поставщики · {{contracts}}',
  'supplierGraph.concentrationHedged.low': 'Поставщики меняются · {{contracts}}',
  'supplierGraph.hhiTitle': 'Индекс концентрации HHI {{n}}',
  'supplierGraph.dependenceFlag': 'Высокая зависимость от одного поставщика',
  'supplierGraph.contracts.one': '{{n}} контракт',
  'supplierGraph.contracts.few': '{{n}} контракта',
  'supplierGraph.contracts.many': '{{n}} контрактов',
  'supplierGraph.suppliers.one': '{{n}} поставщик',
  'supplierGraph.suppliers.few': '{{n}} поставщика',
  'supplierGraph.suppliers.many': '{{n}} поставщиков',
  'supplierGraph.top3Share': 'Доля топ-3',
  'supplierGraph.suppliersBasis': 'из {{n}} поставщиков',
  'supplierGraph.marketShare': 'Доля рынка заказчика',
  'supplierGraph.topNShare': 'топ-{{n}} · {{pct}}%',
  'supplierGraph.footer':
    '{{suppliers}} поставщиков · {{contracts}} контрактов · {{total}} {{currency}}',
  // Soliq registry trust strip — «О заказчике». Rendered on tender-detail
  // (near the buyer/contact area) and on the public buyer profile header.
  'tender.trust.title': 'О заказчике',
  'tender.trust.titleSupplier': 'О поставщике',
  'tender.trust.vat': 'Плательщик НДС',
  'tender.trust.fund': 'Уставный фонд',
  'tender.trust.since': 'Работает с {{year}}',
  'tender.trust.statusLabel': 'Статус',
  'tender.trust.vatLabel': 'НДС',
  'tender.trust.vatYes': 'Плательщик',
  'tender.trust.sinceLabel': 'Работает с',
  'tender.trust.status.ACTIVE': 'Действующее, есть налоговые обязательства',
  'tender.trust.status.TAX_FREE': 'Без налоговых обязательств',
  'tender.trust.status.INACTIVE': 'На стадии ликвидации',
  'tender.trust.status.LIQUIDATED': 'Прекратило деятельность',
  'tender.trust.liquidated': 'Ликвидирована',
  'tender.trust.kgd.DEBTOR_BANKRUPT': 'Признан банкротом по решению суда',
  'tender.trust.kgd.DEBTOR_REHABILITATION': 'Реабилитационная процедура по решению суда',
  'tender.trust.kgd.DEBTOR_LIQUIDATION_NO_BANKRUPTCY': 'Ликвидация без банкротства по решению суда',
  'tender.trust.kgd.BANKRUPT': 'В списке банкротов КГД',
  'tender.trust.kgd.PSEUDO_ENTERPRISE': 'Признан лжепредприятием',
  'tender.trust.kgd.REGISTRATION_INVALID': 'Регистрация признана недействительной',
  'tender.trust.kgd.REREGISTRATION_INVALID': 'Перерегистрация признана недействительной',
  'tender.trust.kgdSource': 'По данным Комитета государственных доходов МФ РК',
  // Государственный рейтинг DXMAP (xarid.icppa.uz). Только буква: шкалу
  // (0-100) источник отдаёт, а пороги между буквами не публикует, поэтому
  // число хранится и не показывается. Лицензия DXMAP требует указания
  // источника везде, где данные переиспользуются, — отсюда третий ключ.
  'tender.trust.dxmapRatingLabel': 'Рейтинг устойчивости',
  'tender.trust.dxmapSectorLabel': 'Вид деятельности',
  'tender.trust.dxmapSource': 'рейтинг устойчивости Налогового комитета, по данным',
  'requirements.title': 'Требования закупки',
  'requirements.scope': 'Предмет закупки',
  'requirements.qualifications': 'Квалификационные требования',
  'requirements.technicalSpecs': 'Технические характеристики',
  'requirements.delivery': 'Сроки поставки',
  'requirements.warranty': 'Гарантия',
  'requirements.payment': 'Условия оплаты',
  // Блок «квалификационные требования» до 25.09.2026 просто исчезал, когда
  // список пуст, — а пуст он на 69% живого каталога. Четыре разные причины
  // выглядели одинаковым ничем, и дыра в НАШЕМ конвейере читалась как дыра
  // в лоте. Ниже — подпись об источнике списка и честная причина пустоты.
  'requirements.sourceDocuments': 'по документам лота',
  'requirements.sourceMarketplace': 'по данным площадки {{name}}',
  // Название площадки — часть Pro (05.10.2026): без Pro подпись не называет её.
  'requirements.sourceMarketplaceGeneric': 'по данным площадки-источника',
  // Критерий, несоответствие которому площадка помечает как основание
  // отклонить заявку. Те же критерии, что считает «Параметры процедуры».
  'requirements.disqualifying': 'отклонение заявки',
  'requirements.noneStated':
    'Мы разобрали документы лота — квалификационные требования в них не указаны.',
  'requirements.noDocuments':
    'Площадка {{name}} не публикует документы здесь — смотрите на источнике.',
  'requirements.noDocumentsGeneric':
    'Документы этого лота публикуются только на площадке-источнике.',
  // Зрителю без Pro площадку не называем и ссылку не даём — говорим, где она.
  'requirements.noDocumentsLocked':
    'Документы этого лота лежат на площадке-источнике. Открыть лот на площадке можно в Pro.',
  'requirements.openOnSource': 'Открыть лот на площадке',
  'requirements.unreadable': 'Документ приложен сканом или в формате, который мы пока не читаем.',
  'requirements.openDocument': 'Открыть документ',
  'requirements.pending': 'Разбираем документы, обычно до 2 часов.',
  'requirements.locked': 'Разбор требований доступен в тарифе Pro',
  'requirements.lockedCta': 'Посмотреть тарифы',
  'plans.checkout': 'Оформить',
  'plans.checkoutGuest': 'Войти, чтобы оформить',
  'plans.redirecting': 'Перенаправляем…',
  'plans.tinRequired': 'Для этого тарифа нужен ИНН компании. Укажите его — и вернитесь к оплате.',
  'plans.checkoutError': 'Не удалось оформить. Попробуйте ещё раз.',
  'plans.loadError': 'Не удалось загрузить тарифы.',
  'plans.loadRetry': 'Повторить',
  'plans.payWithPayme': 'Оплатить · Payme',
  'plans.payOnce': 'Разовый платёж',
  // The price rides IN the button. This card is the only screen where the two
  // prices can be compared, and a CTA that reveals a higher amount only after
  // the click is the kind of surprise that ends a purchase.
  'plans.payOnceWithPrice': 'Разовый платёж — {{amount}}',
  'plans.payOnceNote': 'Без автопродления · на 10% дороже подписки',
  'plans.payOnceNoRenew': 'Разовый платёж без автопродления',
  'plans.onceAmount': 'К оплате: {{amount}} за 1 месяц',
  'plans.payWithClick': 'Оплатить через Click',
  'plans.payOnceViaPayme': 'Оплатить через Payme',
  // Label above the two-gateway pay-once tier on monthly (subscribe is primary).
  'plans.payOnceOrLabel': 'Или оплатить разово — {{amount}}',
  // Chooser label on yearly, where pay-once is the primary action.
  'plans.payMethodLabel': 'Способ оплаты',
  'plans.clickCards': 'Uzcard · Humo · Visa',
  'plans.paymentVia': 'Оплату обрабатывают',
  'plans.payByAccount': 'Оплата по расчётному счёту',
  'plans.invoiceSub': 'Публичная оферта + счёт-фактура для бухгалтерии',
  'plans.orPayByCard': 'Или оплатить картой через приложение',
  'plans.yearAccessNote': 'Без автопродления — доступ на 12 месяцев',
  'plans.payWithCard': 'Оплатить картой (Uzcard/Humo)',
  'plans.payByInvoice': 'Оплата по счёту (для юр. лиц)',
  'plans.paymeOnlyNote': 'Помесячная оплата — только онлайн через Payme.',
  'plans.bankTransferTitle': 'Реквизиты для оплаты',
  'plans.bankAmount': 'Сумма к оплате',
  'plans.downloadInvoice': 'Скачать счёт на оплату',
  'plans.bankNote': 'Тариф Pro активируется после поступления оплаты на расчётный счёт.',

  // ── Оплата по счёту: трёхшаговая модалка (2026-09-15) ────────────────────
  // Счёт — русский бухгалтерский документ, и сам PDF печатается только
  // по-русски (узбекского варианта формы «Счёт на оплату» нет). Интерфейс
  // вокруг него локализован полностью: узбекоязычный покупатель заполняет
  // форму на своём языке и получает тот же документ.
  'invoiceFlow.tinLabel': 'ИНН вашей организации',
  'invoiceFlow.tinLooking': 'Ищем в реестре…',
  'invoiceFlow.nameLabel': 'Название организации',
  'invoiceFlow.namePlaceholder': 'ООО «Пример»',
  'invoiceFlow.tinIncomplete': '{{tin}} состоит из {{tinDigits}} цифр',
  'invoiceFlow.nameRequired': 'Впишите название — оно печатается в счёте',
  'invoiceFlow.accessPeriod':
    'Доступ 12 месяцев со дня активации — при оплате сегодня до {{date}}.',
  'invoiceFlow.issue': 'Выставить счёт',
  'invoiceFlow.issuing': 'Выставляем…',
  'invoiceFlow.errIssue': 'Не удалось выставить счёт. Проверьте ИНН и попробуйте ещё раз.',
  'invoiceFlow.readyTitle': 'Счёт № {{number}}',
  'invoiceFlow.purposeLabel': 'Назначение платежа (обязательно)',
  'invoiceFlow.purposeWarning':
    'Для каждого счёта своё назначение. Назначение из другого счёта задержит зачисление. Оплата от третьего лица не принимается.',
  'invoiceFlow.copy': 'Скопировать',
  'invoiceFlow.copied': 'Скопировано',
  'invoiceFlow.download': 'Скачать PDF',
  'invoiceFlow.sendEmail': 'Отправить на почту',
  'invoiceFlow.emailSent': 'Отправлено на почту',
  'invoiceFlow.sendTelegram': 'Отправить в Telegram',
  'invoiceFlow.telegramSent': 'Отправлено в Telegram',
  'invoiceFlow.errSend': 'Не удалось отправить. Скачайте PDF или попробуйте позже.',
  'invoiceFlow.errDownload': 'Не удалось скачать PDF — отправьте счёт на почту или в Telegram.',
  'invoiceFlow.errNoEmail':
    'У аккаунта нет почтового адреса — скачайте PDF или отправьте в Telegram.',
  'invoiceFlow.errNoTelegram': 'Telegram не подключён — подключите его в настройках уведомлений.',
  // Показывается ВМЕСТО кнопки «В Telegram», когда аккаунт не связан: кнопка,
  // которая может только отказать, — не выбор, а ловушка.
  'invoiceFlow.connectTelegram': 'Подключите Telegram в профиле, чтобы получать счёт и уведомления',
  'invoiceFlow.activationNote':
    'Доступ откроется в течение 3 рабочих дней после поступления средств.',
  'invoiceFlow.needFaster': 'Нужно быстрее?',
  'invoiceFlow.savedNote': 'Счёт сохранён в вашем кабинете — его можно скачать и отправить снова.',
  'plans.freeStart': 'Начать бесплатно',
  'plans.currentPlan': 'Текущий тариф',
  'plans.otherMethods': 'Другие способы оплаты',
  'plans.toggleMonthly': 'Месяц',
  'plans.toggleYearly': 'Год',
  'plans.periodToggleLabel': 'Период оплаты',
  'plans.badgePopular': 'Популярный',
  'plans.badgeBestValue': 'Выгодно',
  'plans.savings': 'Экономия ~{{percent}}% против помесячной',
  'plans.badgeX2': '×{{multiple}} выгода',
  'plans.savingsX2': 'Год за цену 6 месяцев — экономия {{som}} {{currency}}',
  'plans.refYearAria': 'Помесячно за год вышло бы {{som}} {{currency}}',
  'plans.consentPrefix': 'Оплачивая, вы соглашаетесь с',
  'plans.consentOffer': 'офертой',
  'plans.consentAnd': 'и',
  'plans.consentPrivacy': 'политикой конфиденциальности',
  'plans.consentSuffix': '.',
  // ── Footer ─────────────────────────────────────────────────────
  'footer.plans': 'Тарифы',
  // ── Directory (the hub-of-hubs, /directory) ──────────────────────────────
  'directory.title': 'Все категории и регионы',
  'directory.intro':
    'Полный указатель разделов каталога: тендеры и госзакупки {{countryGen}} по направлению закупки и по региону заказчика. Рядом с каждым разделом — число активных тендеров в нём.',
  'directory.seoTitle': 'Тендеры по категориям и регионам {{countryGen}}',
  'directory.seoDesc':
    'Указатель всех разделов каталога госзакупок {{countryGen}}: тендеры по 31 направлению закупки и по 14 регионам, с числом активных тендеров в каждом.',
  'directory.categories.h2': 'По направлению закупки',
  'directory.categories.intro':
    'Направление определяется товарной группой лота — от стройматериалов до ИТ и медицины.',
  'directory.regions.h2': 'По региону заказчика',
  'directory.regions.intro': 'Регион — это место нахождения заказчика, а не место поставки.',
  'directory.companies.h2': 'Компании — участники госзакупок',
  'directory.companies.intro':
    'Каталог поставщиков и заказчиков с историей в госзакупках {{countryGen}}: статус в реестре, надёжность и объём контрактов.',
  'goodStanding.tier.debarred': 'В реестре недобросовестных',
  'goodStanding.tier.liquidated': 'Ликвидирована',
  'goodStanding.tier.flagged': 'В реестре КГД (налоговые риски)',
  'goodStanding.tier.active_supplier': 'Действующий поставщик',
  'goodStanding.tierBuyer.active_supplier': 'Действующий заказчик',
  'goodStanding.tier.active': 'Действующая компания',
  'companies.title': 'Компании в госзакупках {{countryGen}}',
  'companies.intro':
    'Поставщики и заказчики с историей участия в госзакупках. Рядом с каждой компанией — статус в реестре и объём контрактов.',
  'companies.seoTitle': 'Каталог компаний-участников госзакупок {{countryGen}}',
  'companies.seoTitlePaged': 'Каталог компаний госзакупок — страница {{page}}',
  'companies.seoDescPaged':
    'Компании-участники госзакупок {{countryGen}} — страница {{page}} из {{totalPages}}, всего {{count}}. Заказчики и поставщики, контракты и суммы — на {{brand}}.',
  'companies.seoDesc':
    'Поставщики и заказчики госзакупок {{countryGen}}: статус в реестре, надёжность и история контрактов по каждой компании.',
  'companies.search': 'Название или ИНН',
  'companies.filter.allSectors': 'Все отрасли',
  'companies.filter.allRegions': 'Все регионы',
  'companies.filter.allRoles': 'Все компании',
  'companies.role.supplier': 'Поставщики',
  'companies.role.buyer': 'Заказчики',
  'companies.role.both': 'И поставщик, и заказчик',
  'companies.rowRole.supplier': 'Поставщик',
  'companies.rowRole.buyer': 'Заказчик',
  'companies.rowRole.both': 'Заказчик и поставщик',
  'companies.contractsAs.supplier': 'Контрактов как поставщик: {{count}}',
  'companies.contractsAs.buyer': 'Контрактов как заказчик: {{count}}',
  'companies.contracts': '{{count}} контрактов',
  'companies.empty': 'Компании не найдены. Измените фильтры.',
  'companies.loadMore': 'Показать ещё',
  'companies.count': 'Найдено компаний: {{count}}',
  'nav.companies': 'Компании',
  'nav.guide': 'Как участвовать',
  'footer.directory': 'Категории и регионы',
  'footer.about': 'О сервисе',
  'footer.guide': 'Гид для поставщиков',
  'footer.offer': 'Публичная оферта',
  'footer.privacy': 'Конфиденциальность',
  'footer.requisites': 'Реквизиты',
  'footer.support': 'Поддержка',
  'nav.about': 'О сервисе',
  'nav.subscription': 'Подписка',
  // ── About page (/about) ────────────────────────────────────────
  'about.pageTitle': 'О сервисе {{brand}}',
  'about.subtitle': 'Агрегатор государственных тендеров и госзакупок {{countryGen}}.',
  'about.lead':
    '{{brand}} — это единый каталог государственных закупок {{countryGen}}. Мы собираем тендеры с официальных площадок в одном месте, добавляем разбор закупок на узбекском и русском языках и помогаем поставщикам быстрее находить подходящие госконтракты.',
  'about.what.title': 'Что мы делаем',
  'about.what.body':
    'Каждые несколько часов мы обновляем каталог бюджетных государственных закупок, определяем регион, категорию и предмет каждого тендера и делаем их удобными для поиска — чтобы вам не приходилось вручную отслеживать десятки площадок.',
  'about.feature.catalog.title': 'Единый каталог',
  'about.feature.catalog.desc':
    'Тысячи актуальных тендеров с фильтрами по региону, категории, бюджету и сроку подачи.',
  'about.feature.ai.title': 'Разбор закупок',
  'about.feature.ai.desc':
    'Краткое описание каждого тендера на узбекском и русском — суть закупки понятна сразу.',
  'about.feature.search.title': 'Умный поиск',
  'about.feature.search.desc':
    'Семантический поиск понимает смысл запроса, а не только точные слова.',
  'about.feature.alerts.title': 'Оповещения в Telegram',
  'about.feature.alerts.desc': 'Сохраняйте поиск и первыми узнавайте о новых подходящих тендерах.',
  'about.audience.title': 'Для кого',
  'about.audience.body':
    'Для поставщиков, подрядчиков и производителей, которые участвуют в государственных закупках {{countryGen}} и хотят первыми видеть релевантные тендеры.',
  'about.sources.title': 'Источники данных',
  'about.sources.body':
    'Мы агрегируем публичные данные с официальных площадок госзакупок {{countryGen}} (xarid.uzex.uz, etender.uzex.uz, xt-xarid.uz и другие). {{brand}} — независимый сервис и не является государственным порталом.',
  // Heading of the press block on /about (components/press-block.tsx). The
  // entries themselves live in content/press.ts, not here — a headline quoted
  // from a publication is content, not UI copy, and must not be "translated".
  'about.press.title': 'О нас пишут',
  'about.contact.title': 'Связаться с нами',
  'about.contact.body': 'По вопросам сотрудничества, подписки и поддержки пишите нам:',
  'about.operator': 'Оператор сервиса — {{legalName}}.',
  'about.operator.requisitesLink': 'Реквизиты',
  'footer.rights': 'Все права защищены.',
  'footer.inn': 'ИНН',
  'footer.phone': 'Телефон',
  // ── Legal pages (оферта / политика) ────────────────────────────
  'legal.updated': 'Последнее обновление',
  'legal.requisitesHeading': 'Реквизиты Исполнителя',
  // ── Requisites page ────────────────────────────────────────────
  'requisites.pageTitle': 'Реквизиты',
  'requisites.subtitle': 'Юридические и банковские реквизиты оператора сервиса.',
  'requisites.note':
    'Указанные реквизиты используются для оплаты годовой подписки по счёту (для юридических лиц и ИП).',
  // ── Invoice (счёт на оплату) ───────────────────────────────────
  'invoice.pageTitle': 'Счёт на оплату',
  'invoice.title': 'Счёт на оплату',
  'invoice.date': 'Дата',
  'invoice.back': '← К тарифам',
  'invoice.print': 'Печать / PDF',
  'invoice.seller': 'Поставщик (Исполнитель)',
  'invoice.buyer': 'Плательщик (Заказчик)',
  'invoice.buyerName': 'Наименование',
  'invoice.buyerInn': 'ИНН',
  'invoice.itemName': 'Наименование услуги',
  'invoice.itemQty': 'Кол-во',
  'invoice.itemPrice': 'Сумма',
  'invoice.itemPlan': 'Подписка {{name}} (годовая), доступ к сервису {{brandHost}}',
  'invoice.total': 'Итого к оплате',
  'invoice.note':
    'Оплатите указанную сумму на расчётный счёт поставщика. Тариф {{name}} активируется после поступления средств. Назначение платежа: оплата подписки {{name}}, {{brandHost}}.',
  // ── Tender detail extras ───────────────────────────────────────
  'tender.budgetLabel': 'Бюджет',
  'tender.deadlineLabel': 'Срок',
  'tender.daysLeftText': 'осталось {{days}}',
  'tender.nav.description': 'Описание',
  'tender.nav.procedure': 'Порядок',
  'tender.nav.documents': 'Документы',
  'tender.nav.lotDetails': 'Поставка',
  'tender.identity.platform': 'Площадка',
  'tender.lotDetails.title': 'Условия поставки',
  'tender.lotDetails.unitPrice': 'Цена за единицу',
  'tender.lotDetails.qty': 'Количество',
  'tender.lotDetails.unit': 'Единица измерения',
  'tender.lotDetails.deliveryPlace': 'Место поставки',
  'tender.lotDetails.deliveryTerm': 'Срок поставки',
  'tender.lotDetails.advancePct': 'Аванс',
  'tender.lotDetails.paymentType': 'Условия оплаты',
  'tender.lotDetails.paymentTermDays': 'Срок оплаты',
  'tender.lotDetails.positions': 'Позиции лота: {{n}}',
  'tender.lotDetails.incoterms': 'Инкотермс',
  'tender.lotDetails.purchaseType': 'Тип закупки',
  'tender.lotDetails.batchLotCount': 'Лотов в объявлении',
  'tender.lotDetails.batchTotal': 'Сумма закупки',
  'tender.lotDetails.legalAddress': 'Юр. адрес заказчика',
  'tender.nav.requirements': 'Требования',
  'tender.nav.contacts': 'Контакты',
  'tender.nav.integrity': 'Параметры',
  'tenderIntegrity.title': 'Параметры процедуры',
  'tenderIntegrity.hint':
    'Признаки, на которые стоит обратить внимание: перевыставление, единственный участник, залог, требования. Только факты, без оценки.',
  'tenderIntegrity.teaserRelisting': 'Перевыставление лота',
  'tenderIntegrity.teaserDeposit': 'Залог к бюджету',
  'tenderIntegrity.teaserBasis': 'Проверок по документации лота: {{n}}',
  'tenderIntegrity.relisting': 'Перевыставлен из процедуры #{{id}}',
  'tenderIntegrity.prevFailed': 'предыдущая не состоялась',
  'tenderIntegrity.prevParticipants': 'участников в ней: {{n}}',
  'tenderIntegrity.participants': 'Зарегистрировано участников: {{n}}',
  'tenderIntegrity.single': 'Единственный зарегистрированный участник',
  'tenderIntegrity.deposit': 'Залог {{pct}}% бюджета',
  'tenderIntegrity.median': 'медиана по разделу — {{pct}}%',
  'tenderIntegrity.quals': 'Дисквалифицирующих требований: {{n}}',
  'tenderIntegrity.qualsShow': 'Показать требования',
  'tenderIntegrity.weights': 'оценка {{tech}}:{{cost}} (техника:цена)',
  'tenderIntegrity.source': 'По протоколам процедуры и графу закупок',
  'tender.callAction': 'Позвонить',
  'tender.summaryLabel': 'Описание',
  'tender.detailLabel': 'Описание',
  // Unified free overview card (Описание = prose, Спецификация = source line-items).
  'tender.overview.description': 'Описание',
  'tender.overview.specification': 'Спецификация',
  'tender.overview.bidSecurity': 'Обеспечение заявки',
  'tender.documentTextLabel': 'Текст документации',
  'tender.noSummary': 'Резюме для этого тендера пока недоступно.',
  // ── Tender gate card (two-wall model: free = hard Pro wall, 0 opens) ───
  'tender.reveal.title': 'Контакты заказчика',
  'tender.reveal.remaining': 'Осталось открытий в этом месяце: {{count}}',
  'tender.reveal.action': 'Показать контакты',
  // Лот без контактов заказчика: открытие даёт ссылку на оригинал объявления —
  // и это всё, что оно даёт. Пишем это до списания, а не после.
  'tender.reveal.titleNoContact': 'Оригинал объявления',
  'tender.reveal.noContactHint':
    'Заказчик не опубликовал контакты по этому тендеру. Открытие даёт ссылку на оригинал объявления на площадке.',
  'tender.reveal.actionNoContact': 'Открыть оригинал',
  'tender.reveal.pending': 'Открываем…',
  'tender.reveal.ceiling':
    'Бюджет этого тендера выше лимита вашего тарифа. Контакты по таким тендерам доступны на Pro.',
  'tender.reveal.exhausted':
    'Открытия контактов на этот месяц закончились. Лимит обновится 1-го числа — или переходите на Pro без лимита.',
  'tender.reveal.error': 'Не удалось открыть контакты. Попробуйте ещё раз.',
  // ── Per-account read ceiling ────────────────────────────────────────────
  // НЕ стена и НЕ апселл: сюда попадает только тот, кому контакты и так
  // положены. {{limit}} приходит с сервера (READ_LIMIT_CONTACTS_PER_DAY
  // настраивается), {{time}} — момент сброса суточного окна: оно UTC, то есть
  // 05:00 по Ташкенту, поэтому называем ВРЕМЯ, а не «завтра».
  'tender.reveal.limitedDay':
    'Лимит открытия контактов на сегодня исчерпан ({{limit}}). Он снимется в {{time}} по Ташкенту. Если это ошибка — напишите в поддержку.',
  'tender.reveal.limitedMinute':
    'Вы открыли слишком много контактов подряд. Подождите минуту и попробуйте снова. Если это ошибка — напишите в поддержку.',
  'tender.reveal.limitedSupport': 'Написать в поддержку',

  // «Пакет заявки» — за флагом BID_PACKAGE_ENABLED, только для Pro.
  'tender.bidPackage.title': 'Пакет заявки',
  'tender.bidPackage.cta': 'Собрать заявку',
  'tender.bidPackage.statusIdle': 'Не собран',
  'tender.bidPackage.statusReady': 'Готов',
  'tender.bidPackage.statusReadyOn': 'Готов · собран {{date}}',
  'tender.bidPackage.statsDocs': 'обязательных документов {{n}}',
  'tender.bidPackage.statsGaps': 'пропусков {{n}}',
  'tender.bidPackage.statsProfile': 'анкета заполнена {{pct}} %',
  'tender.bidPackage.profileFill': 'Заполнить анкету компании →',
  'tender.bidPackage.details': 'Открыть подробности',
  'tender.bidPackage.detailsHide': 'Скрыть подробности',
  'tender.bidPackage.gateWarn': 'Пакет выйдет с пропусками: анкета заполнена {{pct}} %.',
  'tender.bidPackage.gateLink': 'Заполнить →',
  'tender.bidPackage.building': 'Создаётся…',
  'tender.bidPackage.preparing': 'Готовим документ, пришлём в Telegram и на почту',
  'tender.bidPackage.preparingHint':
    'Можно закрыть страницу — обычно занимает 10–30 секунд. Готовый пакет останется и здесь.',
  'tender.bidPackage.failed': 'Не получилось собрать пакет.',
  'tender.bidPackage.retry': 'Повторить',
  'tender.bidPackage.error': 'Не удалось собрать пакет. Попробуйте ещё раз.',
  'tender.bidPackage.errorNotGranted': 'Доступ к пакету заявки для вашего аккаунта сейчас закрыт.',
  'tender.bidPackage.errorMonthlyLimit':
    'Лимит на этот месяц исчерпан — 3 сборки в месяц. Уже собранные пакеты открываются без ограничений, лимит обновится 1-го числа.',
  'tender.bidPackage.errorGrantLimit':
    'Сборки по вашему доступу закончились. Уже собранные пакеты открываются без ограничений — напишите нам, если нужно больше.',
  'tender.bidPackage.errorRegenCooldown':
    'Пересобрать этот пакет можно раз в час. Текущая версия остаётся доступной.',
  'tender.bidPackage.downloadError': 'Не удалось скачать файл. Попробуйте ещё раз.',
  'tender.bidPackage.stale': 'Объявление изменилось после того, как пакет был собран.',
  'tender.bidPackage.rebuild': 'Собрать заново',
  'tender.bidPackage.regenerate': 'Пересобрать',
  // Дедлайн-гейт: собирать больше нечего, а собранное остаётся скачиваемым.
  'tender.bidPackage.ctaClosed': 'Приём заявок закрыт',
  'tender.bidPackage.errorTenderClosed':
    'Приём заявок по этому лоту закрыт — собрать пакет уже нельзя.',
  // Пересборка упала, но прежний документ на месте и читается.
  'tender.bidPackage.rebuildFailed': 'Пересборка не удалась, показан прежний документ',
  // Коды warnings из контракта статуса. Неизвестный код не рисуется вовсе.
  'tender.bidPackage.warnClosingSoon': 'До конца приёма меньше суток.',
  'tender.bidPackage.warnUzMachineTranslated':
    'Узбекская версия переведена автоматически — проверьте перед подачей.',
  'tender.bidPackage.checkedAgainst': 'Проверено по данным компании {{company}}',
  'tender.bidPackage.noCompany':
    'ИНН в профиле не указан, поэтому проверить требования по вашей компании мы не смогли — все пункты нужно проверить самостоятельно.',
  'tender.bidPackage.admissionOk': 'Можно подавать',
  'tender.bidPackage.admissionBlocked': 'Есть препятствия: {{count}}',
  'tender.bidPackage.admissionTitle': 'Проверка допуска',
  'tender.bidPackage.deadlineLabel': 'Приём до',
  'tender.bidPackage.methodLabel': 'Способ подачи',
  'tender.bidPackage.methodUnknown':
    'площадка ведёт несколько процедур — вид смотрите на карточке лота',
  'tender.bidPackage.submitTitle': 'Куда и как подать',
  'tender.bidPackage.submitEntry': 'Вход на площадку',
  'tender.bidPackage.profileTitle': 'Анкета компании — только недостающее',
  'tender.bidPackage.profileLead':
    'Эти поля не публикует ни один реестр, а формам в пакете они нужны. Спросим один раз.',
  'tender.bidPackage.profileContinue': 'Продолжить',
  'tender.bidPackage.profileSaving': 'Сохраняем…',
  'tender.bidPackage.profileSaveError': 'Не удалось сохранить анкету. Попробуйте ещё раз.',
  'tender.bidPackage.profileSkipHint':
    'Любое поле можно пропустить — в документе на его месте будет видимый пропуск, который вы заполните сами.',
  'tender.bidPackage.profileLink': 'Остальные данные компании — в профиле',
  'tender.bidPackage.groupAuto': 'Проверено по вашим данным',
  'tender.bidPackage.groupAutoHint':
    'Подтверждено по реестру и истории побед. Это не заменяет проверку комиссией.',
  'tender.bidPackage.groupManual': 'Проверьте сами',
  'tender.bidPackage.groupManualHint':
    'Обязательные требования, которые можем подтвердить только вы: сертификаты, справки, нотариальные копии.',
  'tender.bidPackage.groupSoft': 'Пожелания заказчика',
  'tender.bidPackage.emptyGroup': 'В объявлении не указано.',
  'tender.bidPackage.evidence': 'Подтверждается: {{value}}',
  'tender.bidPackage.verdict.ok': 'соответствуете',
  'tender.bidPackage.verdict.fail': 'не проходите',
  'tender.bidPackage.basis.registration': 'По реестру: {{value}}',
  'tender.bidPackage.basis.region': 'Регион компании: {{value}}',
  'tender.bidPackage.basis.legal_form': 'Организационная форма: {{value}}',
  'tender.bidPackage.basis.vat': 'Плательщик НДС: {{value}}',
  'tender.bidPackage.basis.experience': 'Побед в этой отрасли: {{value}}',
  'tender.bidPackage.documents': 'Документы к заявке',
  'tender.bidPackage.mandatory': 'обязательный',
  'tender.bidPackage.optional': 'по желанию',
  'tender.bidPackage.coverLetter': 'Заявка на участие — черновик',
  'tender.bidPackage.offer': 'Коммерческое предложение — черновик',
  'tender.bidPackage.offerHint': 'Цены не заполняем: их ставите вы.',
  // Жёлтая пометка на узбекских черновиках: русский — мастер, uz — перевод
  // отдельным вызовом модели, и прочитать его должен тот, чьё имя на заявке.
  'tender.bidPackage.uzMark': 'проверьте',
  'tender.bidPackage.uzMarkHint':
    'Текст переведён на узбекский автоматически — сверьте перед подачей.',
  'tender.bidPackage.colItem': 'Наименование',
  'tender.bidPackage.colQty': 'Кол-во',
  'tender.bidPackage.colUnit': 'Ед.',
  'tender.bidPackage.colPrice': 'Цена за ед.',
  'tender.bidPackage.download': 'Скачать DOCX',
  'tender.bidPackage.downloading': 'Готовим файл…',
  'tender.bidPackage.sendEmail': 'На почту',
  'tender.bidPackage.sendTelegram': 'В Telegram',
  'tender.bidPackage.sending': 'Отправляем…',
  'tender.bidPackage.sentEmail': 'Отправили на почту.',
  'tender.bidPackage.sentTelegram': 'Отправили в Telegram.',
  'tender.bidPackage.sendHint':
    'Если файл не скачивается — встроенный браузер Instagram или Telegram так умеет, — заберите его почтой или в боте.',
  'tender.bidPackage.sendError': 'Не удалось отправить. Попробуйте ещё раз.',
  'tender.bidPackage.sendNoEmail': 'У аккаунта нет почтового адреса — добавьте его в профиле.',
  'tender.bidPackage.sendNoTelegram': 'Telegram не подключён — привяжите бота в профиле.',
  'tender.bidPackage.disclaimer':
    'Черновик, подготовленный автоматически по тексту объявления и приложенных файлов. Перед подачей сверьте с оригиналом — ответственность за содержание заявки несёт участник.',

  // ── «Подготовить тендерную документацию» — the waitlist button on the lot for
  // everyone WITHOUT the bid-package grant (components/bid-waitlist-button.tsx).
  'tender.bidWaitlist.cta': 'Подготовить тендерную документацию (beta)',
  'tender.bidWaitlist.caption': 'Пакет документов для подачи заявки по этому лоту',
  'tender.bidWaitlist.queued': 'Вы в очереди',
  'tender.bidWaitlist.queuedCaption': 'Откроем доступ и напишем в Telegram',
  'tender.bidWaitlist.error': 'Не получилось встать в очередь. Попробуйте ещё раз.',
  // Under the button for a reader who pressed BEFORE the questionnaire existed:
  // the press is kept, the form is offered again (owner, 2026-09-29).
  'tender.bidWaitlist.captionReprompt': 'Дополните анкету',
  // The queued caption for an account with no Telegram linked.
  'tender.bidWaitlist.queuedCaptionEmail': 'Откроем доступ и напишем на почту',

  // ── The questionnaire behind that button (components/bid-waitlist-form-modal.tsx,
  // owner's decisions 2026-09-29). The terms block sits ABOVE the questions so
  // nobody ticks «Условия понятны» without having seen them.
  'tender.bidWaitlistForm.title': 'Документация для заявки',
  'tender.bidWaitlistForm.beta': 'бета',
  'tender.bidWaitlistForm.intro':
    'Собираем пакет заявки по документации лота: требования, формы и черновики документов. Доступ открываем по очереди.',
  'tender.bidWaitlistForm.termsTitle': 'Условия после беты',
  'tender.bidWaitlistForm.termsLead':
    'Если вы победите с нашей документацией — договор и вознаграждение от суммы контракта:',
  // The scale in сум, as the owner set it — a UZS threshold, not a currency
  // token: on a KZ build it would otherwise silently become a tenge scale nobody
  // decided on. Non-breaking spaces keep «до 5 %» on one line in a narrow cell.
  'tender.bidWaitlistForm.tier1Range': 'до 100 млн сум',
  'tender.bidWaitlistForm.tier1Fee': 'до 5 %',
  'tender.bidWaitlistForm.tier2Range': 'до 10 млрд',
  'tender.bidWaitlistForm.tier2Fee': 'до 1 %',
  'tender.bidWaitlistForm.tier3Range': 'свыше 10 млрд',
  'tender.bidWaitlistForm.tier3Fee': 'до 0,5 %',
  'tender.bidWaitlistForm.termsUpload':
    'После подачи вы загружаете нам поданную заявку — по ней мы улучшаем следующую.',
  'tender.bidWaitlistForm.tinLabel': '{{tin}} компании',
  // Длина, а не образец (2026-10-01): «301234567» на телефоне читался как уже
  // введённый ИНН. {{tinDigits}} — 9 в UZ, 12 в KZ.
  'tender.bidWaitlistForm.tinPlaceholder': '{{tinDigits}} цифр',
  'tender.bidWaitlistForm.tinHint': 'по нему увидим ваши победы',
  'tender.bidWaitlistForm.tinMissing': 'Укажите {{tin}} компании — {{tinDigits}} цифр',
  'tender.bidWaitlistForm.supplyLabel': 'Что вы поставляете',
  'tender.bidWaitlistForm.supplyPlaceholder': 'мебель, канцтовары, ремонт кровли',
  'tender.bidWaitlistForm.bidsLabel': 'Сколько тендеров подаёте в месяц',
  'tender.bidWaitlistForm.bids.0': '0',
  'tender.bidWaitlistForm.bids.1_3': '1–3',
  'tender.bidWaitlistForm.bids.4_10': '4–10',
  'tender.bidWaitlistForm.bids.10_plus': 'больше 10',
  'tender.bidWaitlistForm.preparerLabel': 'Кто сейчас готовит документы',
  'tender.bidWaitlistForm.preparer.self': 'сами',
  'tender.bidWaitlistForm.preparer.employee': 'сотрудник',
  'tender.bidWaitlistForm.preparer.broker': 'брокер',
  'tender.bidWaitlistForm.brokerPercentLabel': 'под какой процент',
  'tender.bidWaitlistForm.lotLabel': 'Обычная сумма лота',
  'tender.bidWaitlistForm.lot.to_100m': 'до 100 млн',
  'tender.bidWaitlistForm.lot.to_1b': 'до 1 млрд',
  'tender.bidWaitlistForm.lot.to_10b': 'до 10 млрд',
  'tender.bidWaitlistForm.lot.over_10b': 'больше 10 млрд',
  'tender.bidWaitlistForm.agree': 'Условия понятны, мне это интересно',
  'tender.bidWaitlistForm.termsMissing': 'Отметьте «Условия понятны», чтобы встать в очередь',
  'tender.bidWaitlistForm.submit': 'Встать в очередь',
  'tender.bidWaitlistForm.footnote':
    'Сейчас это ни к чему не обязывает. Ответы учтём, когда будем открывать доступ.',
  'tender.bidWaitlistForm.doneTelegram': 'Мы напишем в Telegram, когда откроем доступ',
  'tender.bidWaitlistForm.doneEmail': 'Мы напишем на почту, когда откроем доступ',
  'tender.bidWaitlistForm.doneOk': 'Понятно',

  // ── «Данные компании для заявок» — the standing profile in the account area.
  // Asked once; the per-lot questionnaire above asks only what a lot adds.
  'bidProfile.title': 'Данные компании для заявок',
  'bidProfile.lead':
    'Подписант, контакты, реквизиты, лицензии, опыт и техника — их подставляет каждый пакет заявки. Заполните один раз: по конкретному лоту спросим только то, чего здесь не хватает.',
  'bidProfile.completeness': 'Заполнено {{filled}} из {{total}}',
  'bidProfile.save': 'Сохранить',
  'bidProfile.saving': 'Сохраняем…',
  'bidProfile.saved': 'Сохранили.',
  'bidProfile.saveError': 'Не удалось сохранить. Попробуйте ещё раз.',
  'bidProfile.loadError': 'Не удалось загрузить данные компании.',
  'bidProfile.skipHint':
    'Любое поле можно оставить пустым — в документе на его месте будет видимый пропуск, который вы заполните сами.',

  'tender.gate.title': 'Документы и контакты заказчика скрыты',
  'tender.gate.lockedContacts': 'Контакты заказчика',
  'tender.gate.lockedWinnerContacts': 'Контакты победителей прошлых тендеров',
  'tender.gate.lockedDocs': 'Тендерная документация',
  'tender.gate.lockedSummary': 'Полный разбор ТЗ',
  'tender.gate.lockedAnalytics': 'Аналитика по рынку и заказчику',
  'tender.gate.guest': 'Регистрируйтесь бесплатно — сохранённые поиски и Telegram-алерты',
  'tender.gate.free': 'Оформите Pro — контакты заказчика, документы и аналитика рынка',
  // Primary-action labels (sticky rail + mobile bottom bar)
  'tender.cta.register': 'Зарегистрироваться',
  'tender.cta.pro': 'Активировать Pro-тариф',
  'tender.cta.contacts': 'Открыть контакты',
  // ── Free full-tender unlock (monthly free tier, or a campaign grant) ──
  'freeUnlock.title': 'Бесплатное открытие тендера',
  // Deliberately carries NO count and NO period. The button is drawn for two
  // different allowances — the monthly free tier and a one-off campaign grant
  // of N opens — and «1 бесплатно в этом месяце» was a false promise on the
  // second. The number lives in `freeUnlock.remaining` under the button, where
  // it needs no plural agreement with a verb.
  'freeUnlock.buttonFree': 'Открыть данные Pro-тарифа бесплатно',
  'freeUnlock.remaining': 'Осталось бесплатных открытий: {{n}}',
  'freeUnlock.pending': 'Открываем…',
  'freeUnlock.error': 'Не удалось открыть тендер. Попробуйте ещё раз.',
  'freeUnlock.spent': 'Бесплатное открытие использовано — оформить Pro',
  'freeUnlock.needTin': 'Добавьте ИНН компании',
  'freeUnlock.needPhone': 'Подтвердите телефон в Telegram',
  'freeUnlock.phoneTaken': 'Этот номер уже использован на другом аккаунте',
  'freeUnlock.completeProfile': 'Заполнить профиль',
  'freeUnlock.confirmPhone': 'Подтвердить телефон',
  'freeUnlock.orPro': 'или оформить Pro',
  // ── Dashboard ──────────────────────────────────────────────────
  'dashboard.greeting': 'С возвращением',
  // Add-category nudge (shown until the user saves their first search)
  'dashboard.nudge.title': 'Добавьте категорию — получайте оповещения',
  'dashboard.nudge.body':
    'Выберите категорию в каталоге и сохраните её. Мы пришлём уведомление в Telegram или на email, как только появится новый подходящий тендер.',
  'dashboard.nudge.cta': 'Добавить категорию',
  // Onboarding / activation checklist (dashboard)
  'onboarding.title': 'Завершите настройку',
  'onboarding.progress': '{{done}} из {{total}}',
  'onboarding.step.telegram': 'Вход через Telegram',
  'onboarding.step.telegramHint': 'Подключите Telegram ниже, чтобы получать оповещения.',
  'onboarding.step.search': 'Сохраните хотя бы один поиск',
  'onboarding.step.inn': 'Укажите {{tin}} компании',
  'onboarding.step.innHint':
    'Покажем, сколько тендеров выиграла ваша компания. Форма ниже на этой странице.',
  'onboarding.step.searchCta': 'Добавить',
  // ИКПУ niche picker
  'ikpu.picker.placeholder': 'Поиск по названию товара или коду…',
  'ikpu.picker.searching': 'Поиск…',
  'ikpu.picker.noResults': 'Ничего не найдено',
  'ikpu.picker.remove': 'Убрать',
  'ikpu.picker.activeCount': '{{count}} активн.',
  'ikpu.picker.hint': 'Выберите до {{max}} ниш(и)',
  'ikpu.picker.max': 'Выбрано максимум ({{max}}). Уберите нишу, чтобы добавить другую.',
  'onboarding.niche.title': 'Выберите нишу',
  'onboarding.niche.desc':
    'Мы будем присылать в Telegram каждый новый подходящий тендер по этой нише.',
  'onboarding.niche.save': 'Включить алерты',
  'onboarding.niche.saving': 'Сохраняем…',
  'onboarding.niche.saveNetworkError':
    'Не удалось сохранить — проверьте связь. Мы повторили попытку, но соединение прервалось.',
  'onboarding.niche.saveError': 'Не удалось сохранить нишу. Попробуйте ещё раз.',
  'onboarding.done.intro': 'Готово! Алерты включены.',
  'onboarding.done.sent': 'Первый тендер отправлен в Telegram',
  'onboarding.done.sentDesc':
    'Дальше каждый новый подходящий тендер будет приходить автоматически.',
  'onboarding.done.empty': 'Сейчас активных тендеров в этой нише нет.',
  'onboarding.done.emptyAdjacent':
    'Мы пришлём, как только появится. Похожие ниши с активными лотами:',
  'onboarding.done.close': 'Готово',
  // First-login onboarding pop-up
  'onboarding.modal.title': 'Добро пожаловать в {{brand}}!',
  'onboarding.modal.intro': 'Настройте оповещения, чтобы не пропустить подходящие тендеры.',
  'onboarding.modal.tgTitle': 'Подключите Telegram',
  'onboarding.modal.tgDesc': 'Получайте оповещения о новых тендерах прямо в Telegram.',
  'onboarding.modal.searchTitle': 'Добавьте категорию',
  'onboarding.modal.searchDesc':
    'Выберите категорию и сохраните поиск — мы пришлём уведомление о новых подходящих тендерах.',
  'onboarding.modal.searchCta': 'Выбрать категорию',
  'onboarding.modal.later': 'Позже',
  'onboarding.modal.close': 'Закрыть',
  'onboarding.categories.title': 'Выберите категорию',
  'onboarding.categories.desc': 'Новые тендеры и Telegram-алерты по выбранной нише.',
  'onboarding.categories.searchToggle': 'Не нашли? Искать →',
  'onboarding.categories.search': 'Искать категорию…',
  'onboarding.categories.searchNoResults': 'Ничего не найдено',
  'onboarding.categories.searching': 'Идёт поиск…',
  'onboarding.categories.popular': 'Популярные',
  'onboarding.ikpu.label': 'Или по коду товара',
  'onboarding.ikpu.hint': 'Начните вводить — покажем точные ниши по любому запросу',
  'onboarding.categories.section': 'Категории',
  'onboarding.ikpu.section': 'Точные ниши',
  'onboarding.categories.more': 'Ещё {{count}} категорий',
  // Плитка «Ещё N» на первом экране KZ (20.10): число без существительного —
  // «Ещё 3 категорий» было бы с ошибкой.
  'onboarding.categories.showMore': 'Ещё {{count}}',
  'onboarding.saved': 'Сохранено — оповещения о новых тендерах в вашей нише включены.',
  'onboarding.stepOf': 'Шаг {{n}} из {{total}}',
  'onboarding.back': '← Назад',
  'onboarding.tg.cta': 'Узнавайте о новых тендерах первыми',
  'onboarding.tg.connectedDone': 'Telegram подключён — всё готово.',
  'onboarding.sample.bot': '{{brand}} bot',
  'onboarding.sample.title': 'Новый тендер по вашей нише',
  // Generic fallback title; per-category examples below keep the preview on-topic.
  'onboarding.sample.tender': '«Поставка товаров для государственного учреждения»',
  'onboarding.sample.tender.construction': '«Капитальный ремонт здания школы»',
  'onboarding.sample.tender.automotive': '«Поставка автомобилей для нужд учреждения»',
  'onboarding.sample.tender.food': '«Поставка продуктов питания для детского сада»',
  'onboarding.sample.tender.consulting': '«Услуги технического надзора за строительством»',
  'onboarding.sample.tender.events-culture':
    '«Организация и проведение торжественного мероприятия»',
  'onboarding.sample.tender.electrical': '«Поставка и монтаж трансформаторной подстанции»',
  'onboarding.sample.tender.machinery': '«Поставка насосного оборудования»',
  'onboarding.sample.tender.water-environmental': '«Реконструкция сетей водоснабжения»',
  'onboarding.sample.tender.energy-fuel': '«Поставка дизельного топлива»',
  'onboarding.sample.tender.transport-logistics': '«Услуги перевозки грузов»',
  'onboarding.sample.tender.financial-legal': '«Услуги аудита финансовой отчётности»',
  'onboarding.sample.tender.agriculture': '«Поставка минеральных удобрений»',
  'onboarding.sample.tender.chemicals': '«Поставка лакокрасочных материалов»',
  'onboarding.sample.tender.office-supplies': '«Поставка канцелярских товаров»',
  'onboarding.sample.tender.printing-publishing': '«Услуги печати учебных пособий»',
  'onboarding.sample.tender.cleaning-sanitation': '«Услуги уборки административных зданий»',
  'onboarding.sample.meta': '💰 2 400 000 000 {{currency}} · ⏰ осталось 12 дней',
  // The REAL first match's own numbers (2026-10-06) — never a real title over
  // the canned «2 400 000 000 · 12 дней» line above.
  'onboarding.sample.budget': '💰 {{amount}} {{currency}}',
  'onboarding.sample.daysLeft': '⏰ осталось {{n}} {{word}}',
  // Honest alert status: an unconfirmed address with no Telegram gets ONE digest.
  'alerts.unconfirmed': 'Почта не подтверждена — придёт одна подборка.',
  'alerts.unconfirmed.cta': 'Подтвердить почту',
  'dashboard.alerts.searchesCount': 'Сохранённых поисков: {{count}}.',
  // Where a letter's «Подтвердить почту» button lands (`?emailConfirm=`).
  'emailConfirm.ok': 'Почта подтверждена — подборки будут приходить на неё.',
  'emailConfirm.expired': 'Ссылка устарела. Подтвердите почту кодом.',
  'emailConfirm.invalid': 'Ссылка не сработала. Подтвердите почту кодом.',
  'emailConfirm.signIn':
    'Войдите на сайт — подтвердить почту можно в строке «Подтвердить почту» над каталогом.',
  'emailConfirm.close': 'Закрыть',
  'onboarding.categories.pickPrompt': 'Выберите категорию, чтобы продолжить',
  'onboarding.cta.connect': 'Получать «{{category}}» в Telegram',
  'onboarding.cta.finish': 'Готово',
  // Same nudge on the catalog (points to the «Категория» filter above)
  'catalog.nudge.compact': 'Выберите категорию и сохраните — новые тендеры придут в Telegram.',
  'dashboard.alerts': 'Оповещения',
  'dashboard.alerts.empty': 'Оповещения не настроены.',
  'dashboard.alerts.active': 'Активно: {{count}} — новые подходящие тендеры приходят в Telegram.',
  'dashboard.alerts.activeEmail':
    'Активно: {{count}} — новые подходящие тендеры приходят на почту.',
  'dashboard.alerts.activeBoth':
    'Активно: {{count}} — новые подходящие тендеры приходят в Telegram и на почту.',
  'dashboard.alerts.allChannelsOff':
    'Сохранённых поисков: {{count}}, но все каналы уведомлений выключены — вы ничего не получите.',
  'dashboard.alerts.connectTg': 'Подключите Telegram выше, чтобы получать оповещения.',
  'dashboard.alerts.noSearches':
    'Сохраните поиск, чтобы получать оповещения о новых тендерах в вашей нише.',
  'dashboard.notifications': 'Уведомления о новых тендерах',
  'dashboard.notifications.hint':
    'Оповещения о подходящих тендерах в Telegram или на email. Выключите, чтобы приостановить все уведомления.',
  'dashboard.notifications.email': 'Email-уведомления',
  'dashboard.notifications.email.hint': 'Подходящие тендеры приходят на вашу почту.',
  'dashboard.notifications.telegram': 'Telegram-уведомления',
  'dashboard.notifications.telegram.hint': 'Подходящие тендеры приходят в Telegram.',
  'dashboard.notifications.telegram.connectFirst': 'Подключите Telegram выше',
  'dashboard.plan': 'Ваш тариф',
  'dashboard.plan.free': 'Бесплатный тариф — перейдите, чтобы открыть контакты и экспорт.',
  'dashboard.plan.active': 'Тариф {{plan}} активен — действует до {{date}}.',
  'dashboard.plan.manage': 'Управление подпиской',
  'dashboard.plan.autoRenewOn': 'Автопродление включено',
  'dashboard.plan.autoRenewOff': 'Автопродление выключено',
  'dashboard.matches.week': 'Ваши сохранённые поиски нашли {{count}} новых тендеров за 7 дней.',
  'dashboard.matches.none':
    'За последние 7 дней новых совпадений по вашим сохранённым поискам нет.',
  // ── Support / contact-us ───────────────────────────────────────
  'support.trigger': 'Помощь и поддержка',
  'support.title': 'Помощь и поддержка',
  'support.desc': 'Опишите проблему или идею — мы свяжемся с вами по email.',
  'support.dashboard.desc': 'Есть вопрос или пожелание? Напишите нам — мы поможем.',
  'support.emailPrefix': 'Напишите нам на почту:',
  'support.telegramPrefix': 'Или напишите нам в Telegram:',
  'support.phonePrefix': 'Или позвоните:',
  'support.categoryLabel': 'Категория',
  'support.category.improvement': 'Улучшение',
  'support.category.bug': 'Баг системы',
  'support.category.subscription': 'Подписка',
  'support.category.notification': 'Проблема с уведомлением',
  'support.category.other': 'Другое',
  'support.messageLabel': 'Сообщение',
  'support.messagePlaceholder': 'Расскажите, что случилось или что можно улучшить…',
  'support.emailLabel': 'Email для ответа',
  'support.submit': 'Отправить',
  'support.sending': 'Отправка…',
  'support.success': 'Спасибо! Мы свяжемся с вами.',
  'support.done': 'Готово',
  'support.error': 'Не удалось отправить. Попробуйте ещё раз.',
  'support.invalid': 'Выберите категорию, введите сообщение (от 5 символов) и корректный email.',
  'support.close': 'Закрыть',
  // ── Billing return (post-payment landing) ──────────────────────
  'billing.return.pageTitle': 'Оплата получена',
  'billing.return.title': 'Спасибо за оплату!',
  'billing.return.body':
    'Платёж получен и обрабатывается. Ваш тариф активируется автоматически в течение нескольких минут.',
  // Shown INSTEAD of `body`/`note` once the refreshed session actually carries
  // the subscription. The pending pair ("обрабатывается… активируется в течение
  // нескольких минут", "если не активировался — напишите нам") is written for a
  // provider callback still in flight; printed next to «Тариф Pro активен» it
  // contradicts itself and re-opens a doubt the page exists to close.
  'billing.return.bodyActive': 'Оплата прошла успешно — доступ уже открыт.',
  'billing.return.planActive': 'Тариф {{plan}} активен',
  'billing.return.paidUntil': 'Доступ открыт до {{date}}',
  'billing.return.nextCharge': 'Автопродление включено · следующее списание {{date}}',
  'billing.return.noteActive':
    'Детали подписки и оплаты — в личном кабинете. Появились вопросы — напишите на {{brandEmail}}.',
  'billing.return.attachTitle': 'Подключите автопродление',
  'billing.return.attachBody':
    'Доступ закончится {{date}}. Привяжите карту — и подписка продлится сама, без повторной оплаты.',
  'billing.return.attachCta': 'Привязать карту',
  'billing.return.orderRef': 'Номер заказа',
  'billing.return.ctaCatalog': 'Перейти к тендерам',
  'billing.return.ctaTender': 'Вернуться к тендеру',
  'billing.return.ctaDashboard': 'В личный кабинет',
  'billing.return.note':
    'Если тариф не активировался через несколько минут, напишите на {{brandEmail}} — мы поможем.',
  // ── Billing return: the payment was REFUSED ────────────────────
  // Shown when the gateway said so in the return URL (`octo_status=canceled`,
  // a negative Click `payment_status`) or the order resolved to `cancelled`.
  // One calm paragraph, no blame, no raw gateway codes — the four decline
  // classes below are the only ones we can word honestly.
  'billing.return.failedPageTitle': 'Платёж не прошёл',
  'billing.return.failedTitle': 'Платёж не прошёл',
  'billing.return.failedBody':
    'Банк отклонил платёж или оплата была отменена — подписка не активирована. Можно попробовать ещё раз: той же картой, другой картой или другим способом оплаты.',
  'billing.return.failedReasonFunds': 'На карте не хватило средств.',
  'billing.return.failedReasonCard': 'Банк не принял данные карты.',
  'billing.return.failedReason3ds': 'Подтверждение 3-D Secure не прошло.',
  'billing.return.failedReasonExpired': 'Срок действия карты истёк.',
  'billing.return.failedRetry': 'Попробовать ещё раз',
  'billing.return.failedNote':
    'Если деньги всё же списались — напишите на {{brandEmail}}, разберёмся.',
  // ── Team seats ─────────────────────────────────────────────────
  'team.pageTitle': 'Команда',
  'team.subtitle': 'Доступ к Pro для сотрудников по одной подписке.',
  'team.seats': 'Занято мест: {{used}} из {{limit}}',
  'team.role.owner': 'Владелец',
  'team.role.member': 'Сотрудник',
  'team.joined': 'В команде с',
  'team.rename': 'Переименовать',
  'team.renameLabel': 'Название команды',
  'team.renameSave': 'Сохранить',
  'team.renameCancel': 'Отмена',
  'team.invite': 'Пригласить',
  'team.inviteTitle': 'Ссылка-приглашение',
  'team.inviteHint':
    'Отправьте эту ссылку сотруднику — например в Telegram. Она одноразовая и действует 7 дней.',
  'team.inviteCopy': 'Скопировать',
  'team.inviteCopied': 'Скопировано',
  'team.inviteClose': 'Закрыть',
  'team.remove': 'Удалить',
  'team.removeConfirm': 'Удалить сотрудника из команды? Он сразу потеряет доступ к Pro.',
  // Outstanding invitation links, listed under the roster for the owner only.
  'team.invitesTitle': 'Неиспользованные приглашения',
  'team.inviteExpires': 'Действует до {{date}}',
  // Fallback when the expiry can't be formatted — the row still has to say
  // what it is, rather than render an empty line next to a revoke button.
  'team.inviteOutstanding': 'Ссылка активна',
  'team.revoke': 'Отозвать',
  'team.revokeConfirm':
    'Отозвать приглашение? Ссылка сразу перестанет работать — войти в команду по ней будет нельзя.',
  'team.leave': 'Выйти из команды',
  'team.leaveConfirm':
    'Выйти из команды? Вы сразу потеряете доступ к Pro по подписке команды. Вернуться можно будет только по новому приглашению.',
  'team.disband': 'Распустить команду',
  'team.disbandConfirm':
    'Распустить команду? Сотрудников в команде: {{count}} — все они сразу потеряют доступ к Pro, а неиспользованные приглашения перестанут работать. Действие необратимо.',
  'team.noSeats': 'Все места заняты. Освободите место, чтобы пригласить ещё.',
  // The owner can now SEE their unused links (the list above) and revoke one on
  // the spot, so this no longer hedges with "or wait for it to expire".
  'team.tooManyInvites':
    'Слишком много неиспользованных ссылок-приглашений. Отзовите одну из них в списке выше, чтобы создать новую.',
  'team.create': 'Создать команду',
  'team.emptyTitle': 'Командный доступ',
  'team.emptyBody': 'Тариф «Бизнес» даёт 3 места: вы и двое сотрудников.',
  'team.planRequired': 'Командный доступ доступен на тарифе «Бизнес».',
  'team.viaBadge': 'Доступ от команды «{{name}}»',
  'team.error': 'Не удалось загрузить команду. Попробуйте позже.',
  'team.genericError': 'Не удалось выполнить действие. Попробуйте ещё раз.',
  // ── Team seats: /join/:token ──────────────────────────────────
  'join.title': 'Приглашение в команду',
  'join.signedOut': 'Войдите или зарегистрируйтесь, чтобы принять приглашение.',
  'join.accept': 'Принять приглашение',
  'join.accepting': 'Принимаем…',
  'join.success': 'Готово! Вы в команде «{{name}}».',
  'join.goToTeam': 'Перейти в команду',
  // Advisory shown on /join when the invitee ALREADY pays for their own plan.
  // Entitlement resolves to their own subscription first, so the seat only
  // starts working once that plan ends — say so before they accept.
  'join.ownSubscription':
    'У вас уже есть своя подписка до {{date}}. Она остаётся основной — место в команде начнёт действовать после её окончания.',
  // Same notice when the period end is unknown (currentPeriodEnd is nullable).
  'join.ownSubscriptionNoDate':
    'У вас уже есть своя подписка. Она остаётся основной — место в команде начнёт действовать после её окончания.',
  // ── The preview, rendered from `GET /teams/invitations/:token` BEFORE the
  // button. The page used to show a title and «Принять» and nothing else, so
  // an invitee could not tell whose team it was or what the seat gave them.
  'join.alreadyMember': 'Вы уже в команде «{{name}}».',
  'join.invitedBy': 'Пригласил: {{name}}',
  // `{{plan}}` is the OWNER's plan name from the API (Бизнес / Pro), followed
  // by what a seat on it actually opens. Deliberately one generic line rather
  // than a per-plan benefit list: /plans has no single key that states the
  // three together, and a seat is worth the same on any seat-bearing plan.
  'join.teamPlan':
    'Тариф команды: {{plan}} — откроются контакты заказчиков, документация и аналитика',
  'join.expiresAt': 'Ссылка действует до {{date}}',
  'join.error.invite_not_found': 'Ссылка недействительна.',
  'join.error.invite_expired': 'Срок действия ссылки истёк. Попросите новую.',
  'join.error.invite_used': 'Ссылка уже использована.',
  'join.error.invite_revoked': 'Приглашение отозвано.',
  'join.error.no_seats': 'В команде не осталось свободных мест.',
  // ONE string for both `already_in_team` and `is_team_owner` (join.tsx maps
  // them to the same key). An owner has their own seat too, so the server
  // answers them `already_in_team` — and the old copy sent them to "leave the
  // team", which an owner cannot do (`owner_cannot_leave`). Both exits are
  // named here, so the message is right whichever of the two applies.
  'join.error.already_in_team':
    'Вы уже состоите в команде. Сотрудник может выйти из неё на странице «Команда», а владелец — распустить свою команду там же. После этого откройте приглашение снова.',
  'join.error.generic': 'Не удалось принять приглашение. Попробуйте позже.',
  // Dead ends: an unmatched URL (404) and a route that failed to render.
  'notFound.title': 'Страница не найдена',
  'notFound.body':
    'Возможно, в адресе опечатка или страница больше не существует — например, тендер сняли с публикации.',
  'notFound.action': 'Вернуться в каталог',
  'routeError.badge': 'Ошибка',
  'routeError.title': 'Страница не открылась',
  'routeError.body': 'Что-то пошло не так при загрузке. Обновите страницу или вернитесь в каталог.',
  // ── Offline (22.10): what the shell, the route boundary, a lot and a list
  // say while the browser reports no connection ─────────────────────────
  'offline.banner': 'Нет соединения с интернетом',
  'offline.badge': 'Нет сети',
  'offline.title': 'Нет соединения с интернетом',
  'offline.body': 'Проверьте связь и нажмите «Повторить».',
  'offline.lotBody':
    'Лот откроется сам, когда связь вернётся. Или проверьте связь и нажмите «Повторить».',
  'offline.listBody': 'Нет соединения с интернетом. Список загрузится сам, когда связь вернётся.',
  // ── Kind tabs (goods / works / services filter) ──────────────────
  'catalog.kind.all': 'Все',
  'catalog.kind.goods': 'Товары',
  'catalog.kind.works': 'Работы',
  'catalog.kind.services': 'Услуги',
  'catalog.kind.aria': 'Тип закупки',
  // Accessible name for a tab once counts have loaded — the visible digits
  // are aria-hidden (see kind-tabs.tsx), so this is the only way a
  // screen-reader user hears the count before switching tabs.
  'catalog.kind.ariaLabel': '{{label}}, {{count}} тендеров',
  'company.title': 'Название или {{tin}} вашей организации?',
  'company.subtitle':
    'Покажем, что ваша компания уже выигрывала — или сколько тендеров сейчас открыто в вашей отрасли.',
  'company.benefit.wins': 'Покажем, сколько тендеров ваша компания уже выиграла',
  'company.benefit.alerts':
    'Если победы есть — включим оповещения по тому, что вы уже поставляли, без настройки фильтров',
  'company.benefit.plan': 'Поможем не пропустить тендеры вашего региона и отрасли',
  'company.card.change': 'Изменить',
  'company.card.activity': 'Деятельность:',
  'company.card.status': 'Статус:',
  'company.card.region': 'Регион:',
  'company.card.unknownName': 'Компания не определена',
  'company.card.notFound':
    'Мы не нашли компанию с таким ИНН в реестре. Проверьте номер — или оставьте как есть, если вы ИП: реестр компаний их не возвращает.',
  'company.savedTitle': 'ИНН сохранён',
  'company.done': 'Готово',
  'settings.title': 'Настройки',
  'settings.section.company': 'Компания',
  'settings.section.notifications': 'Уведомления',
  'settings.section.subscription': 'Подписка',
  'settings.section.account': 'Аккаунт',
  'settings.summary.company': 'Компания',
  'settings.summary.noCompany': 'ИНН не указан',
  'settings.summary.plan': 'Тариф',
  'settings.summary.planFree': 'Бесплатный',
  'settings.summary.planFreeHint': 'Контакты заказчиков закрыты',
  'settings.summary.alerts': 'Оповещения',
  'settings.summary.alertsOn': 'Включены',
  'settings.summary.alertsOff': 'Выключены',
  'settings.summary.alertsOffHint': 'Telegram не подключён',
  'settings.account.email': 'Почта',
  // A Telegram-native account has no address; the row says so instead of a name.
  'settings.account.emailMissing': 'не указана',
  'settings.account.emailVerified': 'Подтверждена',
  'settings.account.support': 'Помощь и поддержка',
  // ── Привязка почты к Telegram-аккаунту (21.09) ──────────────────────────
  // У аккаунта, созданного входом через Telegram, адреса нет вообще: синтетический
  // telegram_<id>@users.uztender.com отбивается почтой. Поэтому строка предлагает
  // ДОБАВИТЬ почту, а не подтвердить её.
  'settings.account.attachEmail.hint': 'Почта не указана — счета и коды входа отправлять некуда',
  'settings.account.attachEmail.cta': 'Указать почту',
  'settings.account.attachEmail.label': 'Введите почту — пришлём код подтверждения',
  'settings.account.attachEmail.codeLabel': 'Код отправлен на {{email}}. Введите его:',
  'settings.account.attachEmail.send': 'Прислать код',
  'settings.account.attachEmail.confirm': 'Подтвердить',
  'settings.account.attachEmail.cancel': 'Отмена',
  'settings.account.attachEmail.done': 'Почта привязана',
  'settings.account.attachEmail.error':
    'Не удалось отправить код. Проверьте адрес и попробуйте ещё раз.',
  'settings.account.attachEmail.badCode': 'Код неверный или устарел. Запросите новый.',
  'settings.account.attachEmail.alreadySet': 'У этого аккаунта уже есть настоящая почта.',
  'settings.account.attachEmail.mergeRefused':
    'У этого Telegram-аккаунта есть подписка, напишите в поддержку — мы объединим аккаунты вручную.',
  'company.tinLabel': 'ИНН',
  'company.tinPlaceholder': '{{digits}} цифр',
  // Поле «Название или ИНН» (components/company-lookup.tsx, 18.10).
  'company.lookup.label': 'Введите {{tin}} или название вашей организации',
  'company.lookup.placeholder': 'Название или {{digits}} цифр {{tin}}',
  'company.lookup.searching': 'Ищем…',
  // Ничего не нашли — не тупик: «Продолжить» неактивна, «Пропустить» на месте.
  'company.lookup.empty': 'Не нашли — можно пропустить и добавить позже',
  // То же в настройках, где пропускать нечего.
  'company.lookup.emptyNoSkip': 'Не нашли по названию — введите {{tin}}',
  'company.lookup.tinValue': '{{tin}} {{value}}',
  'company.lookup.wins.one': '{{n}} победа за 2 года',
  'company.lookup.wins.few': '{{n}} победы за 2 года',
  'company.lookup.wins.many': '{{n}} побед за 2 года',
  'company.submit': 'Продолжить',
  'company.checking': 'Проверяем…',
  'company.later': 'Позже',
  'company.saved': 'ИНН сохранён.',
  'company.foundWins': 'Нашли {{n}} {{word}}, которые выиграла ваша компания',
  'company.foundSector': 'В вашей отрасли сейчас открыто {{n}} {{word}}',
  'company.foundRegion': 'В вашем регионе сейчас открыто {{n}} {{word}}',
  // Refusals of the ИНН step, by API code (lib/company-error.ts) — never the raw code.
  'company.error.invalidTin': 'Проверьте ИНН: нужно {{digits}} цифр',
  // KZ only in practice: all digits typed, the БИН/ИИН check digit does not match.
  'company.error.checksum': 'Номер не прошёл проверку — сверьте цифры {{tin}}',
  'company.error.changeLimit': 'ИНН сегодня меняли слишком часто. Попробуйте завтра.',
  'company.error.generic': 'Не удалось сохранить. Попробуйте ещё раз.',
  // «Моя компания»: claim-your-company-profile flow (dashboard card +
  // "Это моя компания?" CTA on public /supplier/:tin and /buyer/:tin pages).
  'claim.card.title': 'Профиль поставщика',
  'claim.card.subtitle':
    'Привяжите профиль компании к своему аккаунту, чтобы получать подборки подходящих тендеров.',
  'claim.card.cta': 'Привязать профиль компании',
  'claim.card.needsTin': 'Сначала укажите ИНН компании в разделе выше.',
  'claim.preview.wins':
    'Мы нашли {{n}} {{word}}, которые выиграла эта компания. Привязать профиль и получать оповещения о новых подходящих тендерах?',
  'claim.preview.none':
    'Истории побед пока нет, но вы можете привязать профиль и получать подборки новых тендеров.',
  'claim.preview.confirm': 'Да, привязать',
  'claim.preview.cancel': 'Отмена',
  'claim.linked.title': 'Профиль привязан',
  'claim.linked.wins': '{{n}} {{word}} в истории побед',
  'claim.linked.note': 'Оповещения о подходящих тендерах включены.',
  'claim.conflict.title': 'Этот ИНН уже привязан к другому аккаунту',
  'claim.conflict.body':
    'Если это ваша компания и доступ к тому аккаунту утерян, напишите в поддержку — поможем разобраться.',
  'claim.error': 'Не удалось выполнить действие. Попробуйте ещё раз.',
  'claim.retry': 'Повторить',
  'phone.title': 'Оставьте телефон',
  'phone.subtitle': 'Свяжемся по счёту и напомним о продлении. Звонков по рекламе не будет.',
  'phone.label': 'Телефон',
  'phone.save': 'Сохранить',
  'phone.saving': 'Сохраняем…',
  'phone.thanks': 'Спасибо — телефон сохранён.',
  'watch.follow': 'Следить за компанией',
  'watch.following': 'Вы следите',
  'watch.hintWinner': 'Пришлём в дайджест, когда эта компания выиграет новый контракт.',
  'watch.hintBuyer': 'Пришлём в дайджест, когда этот заказчик разместит новый контракт.',
  'watch.proRequired': 'Слежение за компаниями доступно в Pro.',
  // The cap is 50 (MAX_WATCHES_PER_USER). Stated, because a click that
  // silently does nothing is worse than a refusal that explains itself.
  'watch.limitReached':
    'Достигнут лимит — 50 организаций. Отпишитесь от одной, чтобы добавить новую.',
  // «Отслеживаемые компании» on /app/alerts — the ONE place to see and undo
  // every follow. Until 2026-09-07 unfollowing meant finding the company page
  // again by hand.
  'watch.list.title': 'Отслеживаемые компании',
  'watch.list.hint': 'Новые контракты и тендеры этих организаций приходят в ваш дайджест.',
  'watch.list.empty':
    'Пока ничего. Нажмите «Следить за компанией» на странице заказчика или поставщика.',
  'watch.list.unfollow': 'Отписаться',
  'watch.list.kindBuyer': 'заказчик',
  'watch.list.kindWinner': 'поставщик',
  'saved.categoriesLabel': 'Категории подписки',
  // Trigger for the shared picker — adds a category, an ИКПУ code OR a niche,
  // so the label names all three rather than only the first one it offered.
  'saved.categoryAdd': 'Добавить категорию, ЕНКТ или нишу',
  'saved.categoryRemove': 'Убрать категорию',
  'saved.ikpuLabel': 'Коды ЕНКТ подписки',
  'saved.ikpuRemove': 'Убрать код ЕНКТ',
  'saved.nicheLabel': 'Ниши подписки',
  'saved.nicheRemove': 'Убрать нишу',
  'saved.regionLabel': 'Регионы',
  'saved.kindLabel': 'Тип закупки',
  'saved.textLabel': 'Слова в описании',
  'saved.textPlaceholder': 'насос',
  'saved.textHint': 'Достаточно одного из этих слов.',
  'saved.anyRegion': 'Все регионы',
  'saved.includeSupplyLabel': 'Также присылать запросы предложений',
  'saved.includeSupplyHint': 'Заявки без бюджета с cooperation.uz по этому фильтру.',
  'saved.customerLabel': 'Заказчик',
  'saved.customerPlaceholder': 'Название организации',
  'saved.customerHint': 'Оповещения придут только по тендерам этого заказчика.',
  'saved.customerRemove': 'Убрать заказчика',

  // ── ИИ-онбординг (v1, 2026-09-24) ────────────────────────────────
  // Экран 1: описание своими словами или ИНН. Экран 2: предложение
  // редактируемыми чипами. Остальное — пять состояний отказа (макет 5).
  'aiOnboarding.step1.title': 'Что вы поставляете?',
  'aiOnboarding.step1.desc': 'Опишите своими словами. Подберём коды, ниши и слова для оповещений.',
  'aiOnboarding.step1.placeholder': 'насосы и запчасти к ним, электродвигатели',
  'aiOnboarding.step1.example': 'Например: насосы и запчасти к ним, электродвигатели.',
  // Поля «Название или ИНН» на шаге ИИ больше нет (22.10): ИНН — свой шаг мастера.
  'aiOnboarding.step1.submit': 'Подобрать',
  'aiOnboarding.step1.loading': 'Подбираем…',
  'aiOnboarding.step1.manual': 'выбрать категорию вручную',
  // Первый экран KZ (20.10): сверху плитки категорий, под ними — выделенный
  // блок ИИ. Ссылки «вручную» там нет: плитки и есть ручной выбор.
  'aiOnboarding.tiles.title': 'Что вы поставляете?',
  'aiOnboarding.tiles.desc': 'Выберите свою сферу',
  'aiOnboarding.tiles.aiTitle': 'Или опишите своими словами',
  'aiOnboarding.tiles.aiCaption': 'ИИ подберёт коды и слова за вас',
  'aiOnboarding.tiles.orTap': 'или нажмите на свою сферу выше',
  'aiOnboarding.quota.counter': '{{left}} из {{limit}} ИИ-поисков',
  'aiOnboarding.quota.left': 'Осталось {{n}} {{word}}. В Pro — 15 в месяц.',
  'aiOnboarding.quota.word.one': 'ИИ-поиск',
  'aiOnboarding.quota.word.few': 'ИИ-поиска',
  'aiOnboarding.quota.word.many': 'ИИ-поисков',
  'aiOnboarding.step2.title': 'Проверьте, что получилось',
  'aiOnboarding.step2.byAi': 'Предложено ИИ по описанию — проверьте коды.',
  'aiOnboarding.row.categories': 'Категории',
  'aiOnboarding.row.subject': 'Категории, ИКПУ и ниши',
  'aiOnboarding.row.ikpu': 'Коды ИКПУ',
  'aiOnboarding.row.niches': 'Ниши',
  'aiOnboarding.row.keywords': 'Слова ru + uz',
  'aiOnboarding.row.regions': 'Регионы',
  'aiOnboarding.row.excludes': 'Исключить',
  'aiOnboarding.counts': 'Сейчас {{open}} открытых лотов · {{perDay}} новых в день',
  'aiOnboarding.locked': 'ещё {{n}} {{word}} — в Pro',
  'aiOnboarding.code.one': 'код',
  'aiOnboarding.code.few': 'кода',
  'aiOnboarding.code.many': 'кодов',
  'aiOnboarding.save': 'Сохранить и получать уведомления',
  'aiOnboarding.saving': 'Сохраняем…',
  'aiOnboarding.saveError': 'Не удалось сохранить поиск. Попробуйте ещё раз.',
  'aiOnboarding.edit': 'Изменить',
  'aiOnboarding.chipRemove': 'Убрать: {{label}}',
  'aiOnboarding.chipAdd': 'Добавить: {{label}}',
  'aiOnboarding.addWord': 'добавить',
  'aiOnboarding.aiMark': 'Заполнено ИИ',
  'aiOnboarding.notUnderstood.title': 'Не понял описание',
  'aiOnboarding.notUnderstood.desc':
    'Уточните, что вы поставляете, — например «насосы и запчасти к ним». Или выберите категорию вручную.',
  'aiOnboarding.notUnderstood.refine': 'Уточнить',
  'aiOnboarding.notUnderstood.manual': 'Выбрать категорию',
  'aiOnboarding.broad.title': 'Слишком широко: {{n}} открытых лотов',
  'aiOnboarding.broad.desc':
    'В оповещения попадёт почти весь каталог. Добавьте слово или регион — станет по делу.',
  'aiOnboarding.broad.narrow': 'Сузить',
  'aiOnboarding.broad.keep': 'оставить как есть',
  'aiOnboarding.broad.budgetChip': 'от {{amount}}',
  'aiOnboarding.none.title': 'Сейчас подходящих лотов нет',
  'aiOnboarding.none.desc':
    'Сохраним поиск и пришлём оповещение о первом же лоте. По таким запросам это обычно 1–2 раза в месяц.',
  'aiOnboarding.none.save': 'Сохранить и ждать',
  'aiOnboarding.none.widen': 'Расширить',
  // Kazakhstan only: the server widened a proposal that matched too few open
  // lots (`proposal.widened`). Uzbekistan never receives one.
  'aiOnboarding.widened.title': 'Подбор расширен, чтобы лоты приходили',
  'aiOnboarding.widened.desc': 'По точному запросу сейчас открыто лотов: {{n}}. Что изменили:',
  'aiOnboarding.widened.class':
    'коды — до класса (первые 6 цифр): придут и соседние позиции того же товара',
  'aiOnboarding.widened.category': 'добавили категорию — придут её лоты со словами из подбора',
  'aiOnboarding.widened.budget': 'без нижней границы бюджета',
  'aiOnboarding.widened.regions': 'по всей стране, без региона',
  'aiOnboarding.widened.restore': 'Вернуть:',
  'aiOnboarding.quotaOut.title': 'ИИ-поиски закончились',
  'aiOnboarding.quotaOut.desc':
    'Два бесплатных подбора использованы. Поиск можно собрать вручную — или открыть Pro, там 15 подборов в месяц.',
  'aiOnboarding.quotaOut.descMonth':
    'Подборы на этот месяц использованы. Поиск можно собрать вручную — новые появятся в начале месяца.',
  'aiOnboarding.quotaOut.manual': 'Собрать вручную',
  'aiOnboarding.quotaOut.pro': 'Открыть Pro',
  'aiOnboarding.error.title': 'ИИ не ответил',
  'aiOnboarding.error.desc':
    'Модель молчит дольше обычного или вернула ошибку — откроем обычный выбор категории, попытка не засчитывается.',
  'aiOnboarding.error.manual': 'Выбрать категорию',
  'aiOnboarding.error.retry': 'Повторить',
  'aiOnboarding.manualFooter':
    'Ручной выбор категории остаётся доступен — ИИ не единственный путь.',
  'aiOnboarding.fill.title': 'Опишите, что нужно, — ИИ заполнит поля',
  'aiOnboarding.fill.placeholder': 'нужны насосы и электродвигатели, Ташкент и область, от 20 млн',
  'aiOnboarding.fill.submit': 'Заполнить с ИИ',
  'aiOnboarding.fill.filled': 'заполнено ИИ — можно менять как обычно',
  // ── Readiness checklist (per-tender, cluster 3, 2026-08-18) ─────
  // ── «Оплатить с компьютера» (XDEV-LINK, 2026-09-26) ─────────────
  // Вторая кнопка под оплатой в разовом листе, ТОЛЬКО на тач-экранах.
  // Замер 14–25.09 по `payment_orders` без сотрудников: телефоны, дошедшие до
  // hosted-страницы Payme на 439 000 сум, оплатили 0 из 51, десктоп на том же
  // шлюзе и той же сумме — 5 из 17. Текст говорит, ЧТО произойдёт, и никогда
  // не обещает доставки, которой не было: канал называет сервер по ответу.
  'plans.payFromDesktop': 'Оплатить с компьютера',
  'plans.payFromDesktopSending': 'Отправляем ссылку…',
  'plans.payLinkSentTelegram': 'Ссылка отправлена в Telegram, действует 24 часа',
  'plans.payLinkSentEmail': 'Ссылка отправлена на почту, действует 24 часа',
  // 422 no_channel: у аккаунта нет ни Telegram, ни настоящего адреса.
  'plans.payLinkNoChannel': 'Некуда отправить ссылку — добавьте почту в профиле',
  'plans.payLinkNoChannelCta': 'Добавить почту',
  'plans.payLinkError': 'Не удалось отправить ссылку. Попробуйте ещё раз',
  // «Оплата по телефону» — SMS-счёт Click/Payme во встроенном браузере (2026-09-27)
  'plans.sms.hint':
    'В браузере {{app}} оплата картой не проходит. Выставим счёт на ваш номер от ООО «FASTAGO» — оплатите его в приложении {{apps}} за минуту',
  'plans.sms.or': ' или ',
  'plans.sms.phoneLabel': 'Номер телефона',
  'plans.sms.pickGateway': 'В каком приложении оплатите',
  'plans.sms.send': 'Выставить счёт на мой номер',
  'plans.sms.sending': 'Выставляем счёт…',
  'plans.sms.sentTitle': '✓ Счёт выставлен на {{phone}}',
  'plans.sms.sentBody':
    'Откройте приложение {{gateway}} — там счёт на оплату от ООО «FASTAGO». Доступ включится автоматически, страницу можно закрыть',
  'plans.sms.sentPaymeSms': 'Payme также пришлёт SMS со ссылкой на оплату.',
  'plans.sms.waiting': 'Ждём оплату…',
  'plans.sms.resendPrompt': 'Счёт не появился за 2 минуты?',
  'plans.sms.resend': 'Выставить ещё раз',
  'plans.sms.resendIn': 'Выставить ещё раз через {{time}}',
  'plans.sms.switchGateway': 'Оплатить через {{gateway}}',
  'plans.sms.paidTitle': 'Оплачено — {{name}} активен',
  'plans.sms.goTenders': 'Перейти к тендерам',
  'plans.sms.fallbackHosted': 'Оплатить на странице Click или Payme',
  'plans.sms.seconds': '{{n}} с',
  'plans.sms.minutes': '{{n}} мин',
  'plans.sms.hours': '{{n}} ч',
  'plans.sms.err.invalid_phone': 'Введите номер: +998 и 9 цифр',
  'plans.sms.err.no_gateway_account':
    'Этот номер не зарегистрирован в {{gateway}}. Выберите другое приложение или номер',
  'plans.sms.err.gateway_declined': '{{gateway}} не принял запрос. Попробуйте другое приложение',
  'plans.sms.err.provider_unavailable': '{{gateway}} сейчас недоступен. Выберите другое приложение',
  'plans.sms.err.rate_limited': 'Слишком много запросов подряд. Попробуйте через {{time}}',
  'plans.sms.err.gateway_error': '{{gateway}} не ответил. Попробуйте ещё раз',
  'plans.sms.err.generic': 'Не удалось выставить счёт. Попробуйте ещё раз',

  // ── Страница /pay/:token ─────────────────────────────────────────
  'payLink.pageTitle': 'Оплата',
  'payLink.loading': 'Открываем оплату…',
  'payLink.title': 'Оплата с компьютера',
  'payLink.lead': 'Заказ уже готов — нажмите кнопку, чтобы перейти на страницу оплаты.',
  'payLink.cta': 'Перейти к оплате',
  'payLink.onceNote': 'Ссылка открывается один раз. Страница оплаты откроется в этом окне.',
  'payLink.backToPlans': 'Вернуться к тарифам',
  'payLink.openPlans': 'Открыть тарифы',
  // 410 — ссылка была настоящей и уже потрачена. Единственное состояние, где
  // можно честно сказать «уже открыта»; всё остальное сервер не различает.
  'payLink.used.title': 'Ссылка уже открыта',
  'payLink.used.body':
    'Она действует один раз. Если оплата не прошла, откройте тарифы и начните заново — деньги не списаны.',
  'payLink.notFound.title': 'Ссылка не действует',
  'payLink.notFound.body':
    'Срок действия — 24 часа. Возможно, заказ уже оплачен или отменён. Откройте тарифы и начните заново.',
  // ── Чек на компьютере без сессии (/billing/return?pl=<токен>) ────
  // Покупатель прошёл по ссылке на машину, где он не залогинен, и оплатил.
  // Страница возврата читает сессию — без токена ей нечего ему сказать.
  'payLink.receipt.paidTitle': 'Оплата прошла',
  'payLink.receipt.paidBody': 'Доступ открыт. Войдите в аккаунт, чтобы начать работу.',
  'payLink.receipt.pendingTitle': 'Ждём подтверждение оплаты',
  'payLink.receipt.pendingBody':
    'Платёж ещё подтверждается банком. Обновите страницу через минуту — или просто войдите в аккаунт, доступ откроется сам.',
  'payLink.receipt.failedTitle': 'Платёж не прошёл',
  'payLink.receipt.failedBody': 'Деньги не списаны. Можно попробовать ещё раз.',
  'payLink.receipt.paidAt': 'Оплачено {{date}}',
  // Подсказка, а не учётные данные: ссылку могли переслать, поэтому адрес
  // замаскирован на сервере. Повод — реальный дубль: клиент с Telegram не
  // узнал вход и завёл второй аккаунт по почте.
  'payLink.receipt.loginTelegram': 'Вы входили через Telegram {{hint}}',
  'payLink.receipt.loginTelegramPlain': 'Вы входили через Telegram',
  'payLink.receipt.loginEmail': 'Вы входили по почте {{hint}}',
  'payLink.receipt.loginEmailPlain': 'Вы входили по почте',
  'payLink.receipt.login': 'Войти в аккаунт',
  // ── /zayavka — лид-форма для кампании Meta на цель Lead (2026-10-06, v2) ──
  'zayavka.pageTitle': 'Заявка: найдём тендеры под ваш товар',
  'zayavka.metaDescription': 'Три шага — и мы подберём открытые госзакупки по вашей нише.',
  'zayavka.progress': '{{n}} из {{total}}',
  'zayavka.back': '← Назад',
  'zayavka.next': 'Далее',
  'zayavka.s1.title': 'Что вы поставляете?',
  'zayavka.s1.search': 'Товар, услуга или код ЕНКТ',
  'zayavka.s1.keyword': 'Искать «{{q}}»',
  'zayavka.s1.loading': 'Считаем открытые лоты…',
  'zayavka.s1.summary': '{{count}} {{lots}} на {{sum}} {{currency}}',
  'zayavka.s1.summaryNoSum': '{{count}} {{lots}}',
  'zayavka.s1.none': 'Сейчас открытых лотов нет',
  'zayavka.lots.one': 'открытый лот',
  'zayavka.lots.few': 'открытых лота',
  'zayavka.lots.many': 'открытых лотов',
  'zayavka.lot.until': 'до {{date}}',
  'zayavka.lot.noBudget': 'Бюджет не указан',
  'zayavka.lot.announced': 'Скоро приём заявок',
  'zayavka.s2.title': 'Немного о вас',
  'zayavka.q.experience': 'Участвовали в тендерах?',
  'zayavka.q.experience.won_this_year': 'Побеждал в этом году',
  'zayavka.q.experience.won_last_year': 'Побеждал в прошлом году',
  'zayavka.q.experience.participated': 'Участвовал, не побеждал',
  'zayavka.q.experience.never': 'Не участвовал',
  'zayavka.q.esign': 'Есть ЭЦП?',
  'zayavka.q.esign.yes': 'Да',
  'zayavka.q.esign.no': 'Нет',
  'zayavka.q.form': 'Форма компании',
  'zayavka.q.form.legal': 'Юридическое лицо (ООО, АО…)',
  'zayavka.q.form.ip': 'ИП',
  'zayavka.q.form.self_employed': 'Самозанятый',
  'zayavka.q.form.individual': 'Физическое лицо',
  'zayavka.q.budget': 'Какой бюджет тендера вам подходит?',
  'zayavka.q.budget.lt_100m': 'До 100 млн',
  'zayavka.q.budget.100m_1b': '100 млн – 1 млрд',
  'zayavka.q.budget.1b_10b': '1–10 млрд',
  'zayavka.q.budget.gt_10b': 'Свыше 10 млрд сум',
  'zayavka.s3.title': 'Как с вами связаться',
  'zayavka.id.label': 'ИНН или ПИНФЛ',
  'zayavka.id.invalid': 'ИНН — 9 цифр, ПИНФЛ — 14',
  'zayavka.phone.label': 'Телефон',
  'zayavka.phone.country': 'Код страны',
  'zayavka.phone.invalid': 'Проверьте номер',
  'zayavka.submit': 'Отправить',
  'zayavka.submitting': 'Отправляем…',
  'zayavka.consent': 'Нажимая, вы соглашаетесь на звонок или сообщение в Telegram',
  'zayavka.error.network': 'Нет связи — нажмите ещё раз',
  'zayavka.error.rateLimited': 'Слишком много заявок с этой сети. Напишите нам в',
  'zayavka.error.generic': 'Не получилось отправить. Напишите нам в',
  'zayavka.thanks.title': 'Спасибо за заявку',
  'zayavka.thanks.body': 'Мы посмотрим ваш профиль и свяжемся — обычно в течение рабочего дня',
  'zayavka.thanks.register': 'Зарегистрироваться бесплатно',
} as const;
